<template>
  <div class = "fixed-content">
    <div>
      <outbound-booking ref="OutboundBooking" mode="YY" :action="onfresh"/>
      <callingApiCenter :paths="['/api/w/gst/WebConfirmLoad','/api/w/apar/create','/api/w/gst/WebSearchCockpit' ,'/api/w/gst/updateyardstage','/api/w/gst/createyardstage']">

         <!-- <md-button class="md-raised custButton "  @click="doAction" ><span class="icons-center material-icons">arrow_back</span>BACK</md-button>
         <md-button class="md-raised custButton "  :disabled="canLast" @click="doBack" ><span class="icons-center material-icons">keyboard_arrow_left</span>LAST</md-button>
         <md-button class="md-raised custButton "  :disabled="canNext" @click="doNext" >NEXT<span class="icons-center material-icons">keyboard_arrow_right</span></md-button> -->

         <md-button class="md-raised custButton "  @click="doAction" ><span class="icons-center material-icons">list_alt</span>To List</md-button>
         <md-button class="md-raised custButton "  :disabled="canLast" @click="doBack" ><span class="icons-center material-icons">fast_rewind</span>Pervious</md-button>
         <md-button class="md-raised custButton "  :disabled="canNext" @click="doNext" ><span class="icons-center material-icons">fast_forward</span>Next</md-button>
         
    <div class=" md-layout md-gutter md-alignment-center ">
      <md-toolbar>
         <h3 class="md-title">Load#: {{paramList.seqNo}}</h3>
         <h3 class="md-title">DO: {{paramList.deliveryOrder}}</h3>
         <h3 class="md-title">CustPO: {{paramList.customerOrder}}</h3>
         <h3 class="md-title">DO Process: {{paramList.doProcess}}</h3>
         <h3 class="md-title">Status: {{paramList.loadStatus}}</h3>
         <md-button class="md-raised custLongButton md-primary" v-if="paramList.loadStatus == 'DCP'" @click="doConfirm"><span class="icons-center material-icons">done_outline</span>Confirm Load</md-button> 
      </md-toolbar>
    </div>

        <div class=" md-layout md-gutter md-alignment-center ">
       <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
          <md-field>
             <label>Container#</label>
             <md-input v-model="paramList.containerNo" disabled></md-input>
          </md-field>
       </div>
       <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
          <md-field>
             <label>Chassis#</label>
             <md-input v-model="paramList.chassisNo" disabled></md-input>
          </md-field>
       </div>
       <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
          <md-field>
             <label>Seal#</label>
             <md-input v-model="paramList.sealNumber" disabled></md-input>
          </md-field>
       </div>
       <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
          <md-field>
             <label>Cont. type</label>
             <md-input v-model="paramList.ctnrType" disabled></md-input>
          </md-field>
       </div>
    </div>   
    <div class=" md-layout md-gutter md-alignment-center ">
       <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
          <md-field>
             <label>Rev Window</label>
             <md-input v-model="paramList.receivingWindow" disabled></md-input> 
          </md-field>
       </div>
       <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
          <md-field>
             <label>Carrier</label>
             <md-input v-model="paramList.carrier" disabled></md-input>
          </md-field>
       </div>

       <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
          <md-field>
             <label>Used Day</label>
             <md-input v-model="paramList.usedDay" disabled></md-input>
          </md-field>
       </div>
       <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
          <md-field>
             <label>CHZ End date</label>
             <md-input v-model="paramList.chzEndDate" disabled></md-input>
          </md-field>
       </div>
    </div>   
    <div class=" md-layout md-gutter md-alignment-center ">
       <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
          <md-field>
             <label>Booking</label>
             <md-input v-model="paramList.bookingNo" disabled></md-input>
          </md-field>
       </div>
       <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
          <md-field>
             <label>Cargo cut-off date</label>
             <md-input v-model="paramList.cutLFD" disabled></md-input>
          </md-field>
       </div>
    </div>   
    <div class=" md-layout md-gutter md-alignment-center ">
       <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
          <md-field>
             <label>Appointment</label>
             <md-input v-model="paramList.appointment" disabled></md-input>
          </md-field>
       </div>
       <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
           <md-field>
             <label>Appt. date</label>
             <md-input v-model="paramList.apptDate" disabled></md-input>
           </md-field>
       </div>
       <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
          <md-field>
             <label>Appt. time</label>
             <md-input v-model="paramList.apptTime" disabled></md-input>
          </md-field>
       </div>
    </div>   

 
         <!-- <div class="dropdown">
           <md-button class="md-raised custButton " @click="doDropDown">Add<span class="icons-center material-icons">add</span></md-button>
           <div id="dropdown" class="dropdown-content" v-if="showDropDown">
             <div v-if="!debug">
               <a v-if="showLISel" href="#" id="dd_li" @click="doAddStage('LI')">Add Load In</a>
               <a v-if="showLOSel" href="#" @click="doAddStage('LO')">Add Load Out</a>
               <a v-if="showEISel" href="#" @click="doAddStage('EI')">Add Empty In</a>
               <a v-if="showEOSel" href="#" @click="doAddStage('EO')">Add Empty Out</a>
               <a v-if="showCISel" href="#" @click="doAddStage('CI')">Add Chassis In</a>
               <a v-if="showCOSel" href="#" @click="doAddStage('CO')">Add Chassis Out</a>
               <br v-if="showTSel"/>
               <a v-if="showTSel" href="#" @click="doAddStage('T')">Add Transfer</a>
            </div>
            <div v-if="debug">
               <a href="#" id="dd_li" @click="doAddStage('LI')">Add Load In</a>
               <a href="#" @click="doAddStage('LO')">Add Load Out</a>
               <a href="#" @click="doAddStage('EI')">Add Empty In</a>
               <a href="#" @click="doAddStage('EO')">Add Empty Out</a>
               <a href="#" @click="doAddStage('CI')">Add Chassis In</a>
               <a href="#" @click="doAddStage('CO')">Add Chassis Out</a>
               <br/>
               <a href="#" @click="doAddStage('T')">Add Transfer</a>
            </div>
           </div> 
         </div> -->
         <!-- <md-button class="md-raised custButton " @click="doSendAll" ><span class="icons-center material-icons">send</span>SEND</md-button> -->
      </callingApiCenter>
    </div>
    <!--
    <div class=" md-layout md-gutter md-alignment-center " v-if="!show">
      <md-toolbar>
         <h3 class="md-title">Load In</h3>
            <md-button class="md-raised custButton "  @click="doLoadEdit()" ><span class="icons-center material-icons">create</span>Edit</md-button>
             <md-button
                  class="custButton md-raised"
                  @click="getLoadBookingAssign()"
                  v-if="loadEdit"
                  :disabled="disableLoadAsgBk"
                  > 
                  Assign BK
              </md-button>
              <md-button 
                  class="custButton md-raised"
                  @click="getLoadBookingUnAssign()"
                  v-if="loadEdit"
                  :disabled="disableLoadUnAsgBk"
                  > 
                  Un-Assign
                </md-button>
             <md-button class="md-raised custButton " v-if="loadEdit" @click="doLoadSave()" ><span class="icons-center material-icons">create</span>Save</md-button>
             <md-button class="md-raised custButton " v-if="loadEdit" @click="doLoadCancel()" ><span class="icons-center material-icons">create</span>Cacnel</md-button>
             <md-button class="md-raised custButton " @click="doLoadSend" ><span class="icons-center material-icons">create</span>SEND</md-button>

            <md-button
                  class="md-icon-button"
                  @click="doHide"
                  id="expand-button"
            >
               <md-icon v-if="loadHide == false">keyboard_arrow_down</md-icon>
               <md-icon v-if="loadHide == true">keyboard_arrow_up</md-icon>
            </md-button>
      </md-toolbar>
    </div>
   -->
    <!--     Load In -->
    <!--
    <div v-if="loadHide">
       <div class=" md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Recv Window</label>
               <md-input v-model="paramList.receivingWindow" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Container#</label>
               <md-input v-model="paramList.containerNo" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Carrier</label>
               <md-input v-model="paramList.carrier" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Cont. type</label>
               <md-input v-model="paramList.ctnrType" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Seal#</label>
               <md-input v-model="paramList.sealNumber" disabled></md-input>
            </md-field>
         </div>
       </div>
      
       <div class=" md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <template v-if="item.editing">
               <auto-complete-master-data-select
                      group="OUTBOUND_GRADE"
                      label="Grade"
                      :init-value="item.grade"
                      :on-item-changed="handleGradeChanged"
               >
               </auto-complete-master-data-select>
            </template>
            <template v-else>
               <md-field>
                 <label>Grade</label>
                 <md-input v-model="paramList.grade" disabled></md-input> 
               </md-field>
            </template>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Chassis#</label>
               <md-input v-model="paramList.chassisNo" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Chassis Vendor</label>
               <md-input v-model="paramList.chassisVendor" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>In Yard Date</label>
               <md-input v-model="paramList.inYardDate" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Scale Date</label>
               <md-input v-model="paramList.gwDate" disabled></md-input>
            </md-field>
         </div>
       </div>

       <div class=" md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Booking</label>
               <md-input v-model="paramList.bookingNo" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Carrier</label>
               <md-input v-model="paramList.carrier" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Cont. type</label>
               <md-input v-model="paramList.ctnrType" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Cnt Drop-off</label>
               <md-input v-model="paramList.ctnrType" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Ingate Date</label>
               <md-input v-model="paramList.chzEndDate" disabled></md-input>
            </md-field>
         </div>
       </div>   
       <div class=" md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Appointment</label>
               <md-input v-model="paramList.appointment" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
             <md-field>
               <label>Appt. date</label>
               <md-input v-model="paramList.apptDate" disabled></md-input>
             </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Appt. time</label>
               <md-input v-model="paramList.apptTime" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Freight Type</label>
               <md-input v-model="paramList.freightType" :disabled = !loadEdit></md-input>
            </md-field>   
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
          </div>
       </div>
       <div class="  md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Dispatch Instruction</label>
               <md-input v-model="paramList.dispatcherInstruction" :disabled="!loadEdit"></md-input>
            </md-field>
         </div>
       </div>   
       <div class="  md-layout md-gutter md-alignment-center ">
       -->
         <!--<div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">-->
       <!--     
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
              <template v-if="loadEdit">
                 <auto-complete-select
                      :label="Driver"
                      :options="drivers"
                      :value="paramList.driverId"
                      :on-item-changed="changeAsgDriverId(paramList.driverId)"
                  >
                 </auto-complete-select>    
              </template> 
              <template v-else>
                <md-field>
                   <label>Driver</label>
                   <md-input v-model="paramList.driverId" disabled></md-input>
                </md-field>
              </template>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
          </div> 
       </div>   
    </div>
   -->
    <!--  End Load In -->
    <div v-for="item in items" :key="item.loadKeyWithStageNo">
      <div class="md-layout md-gutter md-alignment-center ">
           <md-toolbar>
             <h3 class="md-title">Stage#: {{item.loadKeyWithStageNo}}</h3>
             <h3 class="md-title">{{getStageTypeInfo(item.stageType)}}</h3>
             <h3 class="md-title">Status: {{item.stageStatus}}</h3>
             <md-button class="md-raised custLongButton md-primary" v-if="getStageStatusCode(item.stageStatus) == 'DCP'" @click="doConfirmStage(item)"><span class="icons-center material-icons">done_outline</span>Confirm Stage</md-button> 


<!-- 
             <h3 class="md-title">{{getStageTypeInfo(item.stageType)}}</h3>
             <md-button class="md-raised custButton " v-if="!item.newitem" @click="doEdit(item)" ><span class="icons-center material-icons">create</span>Edit</md-button>
             <md-button
                  class="custButton md-raised"
                  @click="getBookingAssign(item)"
                  v-if="item.editing && ( isToShowEmptyOut(item.stageType) || isToShowLoadIn(item.stageType) )"
                  :disabled="disableAsgBk"
                  > 
                  Assign BK
              </md-button>
              <md-button 
                  class="custButton md-raised"
                  @click="getBookingUnAssign(item)"
                  v-if="item.editing && ( isToShowEmptyOut(item.stageType) || isToShowLoadIn(item.stageType) )"
                  :disabled="disableUnAsgBk"
                  > 
                  Un-Assign
                </md-button> -->
             <!---<md-button class="md-raised custButton " v-if="item.editing" @click="doSave(item)" ><span class="icons-center material-icons">create</span>Save</md-button>-->
             <!-- <md-button class="md-raised custButton " v-if="item.editing && !item.newitem" @click="doChkRemoveAndSave(item)" ><span class="icons-center material-icons">save</span>Save</md-button>
             <md-button class="md-raised custButton " v-if="item.editing && item.newitem" @click="doChkRemoveAndSave(item)" ><span class="icons-center material-icons">save</span>New</md-button>
             <md-button class="md-raised custButton " v-if="item.editing && !item.newitem" @click="doCancel(item)" ><span class="icons-center material-icons">cancel</span>Cacnel</md-button> -->
             <!--<md-button class="md-raised custButton " v-if="item.editing" @click="doRemove(item)" ><span class="icons-center material-icons">create</span>Remove</md-button>-->
             <!-- <md-button class="md-raised custButton " @click="doSend(item)" ><span class="icons-center material-icons">send</span>SEND</md-button>
             <md-checkbox v-if="item.editing" v-model="item.remove">Remove</md-checkbox> -->
             <md-button
                  class="md-icon-button"
                  @click="doHideItem(item)"
                  id="expand-button"
                >
             <md-icon v-if="!item.show">keyboard_arrow_down</md-icon>
             <md-icon v-if="item.show">keyboard_arrow_up</md-icon>
             </md-button>

           </md-toolbar>
      </div>
      <div v-if="item.show && isToShowLoadIn(item.stageType)">
        <div class=" md-layout md-gutter md-alignment-center ">
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <!--
            <template v-if="item.editing">
               <auto-complete-master-data-select
                           group="REC_WINDOW"
                           label="Recv Window"
                           :init-value="item.receivingWindow"
                           :on-item-changed="handleWindowsChanged(item)"
                                       >
               </auto-complete-master-data-select>
            </template>
            <template v-else>
               <md-field>
                 <label>Recv Window</label>
                 <md-input v-model="item.receivingWindow" disabled></md-input>
               </md-field>
            </template>
         -->
               <md-field>
                 <label>Recv Window</label>
                 <md-input v-model="item.receivingWindow" disabled></md-input>
               </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Container#</label>
               <md-input v-model="item.containerNo" disabled></md-input>
            </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Carrier</label>
                 <md-input v-model="paramList.carrier" disabled></md-input>
               </md-field>
            </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <md-field>
                <label>Cont. type</label>
                <md-input v-model="paramList.ctnrType" disabled></md-input>
              </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Seal#</label>
               <md-input v-model="paramList.sealNumber" disabled></md-input>
            </md-field>
          </div>
       </div>
      
       <div class=" md-layout md-gutter md-alignment-center ">
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <md-field>
                 <label>Grade</label>
                 <md-input v-model="paramList.grade" disabled></md-input> 
               </md-field>
           </div>
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <md-field>
                 <label>Chassis#</label>
                 <md-input v-model="item.chassisNo" disabled></md-input>
              </md-field>
           </div>
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <template v-if="item.editing">
                <auto-complete-master-data-select
                                 group="STC_CHASSIS_VENDOR"
                                 label="Chassis Vendor"
                                 :init-value="item.chassisVendor"
                                 :on-item-changed="handleChassisVendorChanged(item)"
                           >
                </auto-complete-master-data-select>
              </template> 
              <template v-else>
                <md-field>
                  <label>Chassis Vendor</label>
                  <md-input v-model="item.chassisVendor" disabled></md-input>
                </md-field>
              </template>
           </div>
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <template v-if="item.editing">
                 <datepicker v-model="item.inYardDate" >
                    <label>In Yard Date</label>
                 </datepicker>
              </template>
              <template v-else>
                 <md-field>
                   <label>In Yard Date</label>
                   <md-input v-model="item.inYardDate" disabled></md-input>
                 </md-field>
              </template>
           </div>
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <!--
              <template v-if="item.editing">
                 <datepicker v-model="item.gwDate" >
                    <label>Scale Date</label>
                 </datepicker>
              </template>
              <template v-else>
                 <md-field>
                   <label>Scale Date</label>
                   <md-input v-model="paramList.gwDate" disabled></md-input>
                 </md-field>
              </template>
            -->
               <md-field>
                   <label>Scale Date</label>
                   <md-input v-model="item.gwDate" disabled></md-input>
               </md-field>

           </div>
       </div>

       <div class=" md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Booking</label>
               <md-input v-model="item.bookingNo" :disabled="!item.editing"></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <md-field>
                 <label>Load In Carrier</label>
                 <md-input v-model="paramList.carrier" disabled></md-input>
               </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="GST_CTNRTYPE"
                              label="Load In Cont. Type"
                              :init-value="item.ctnrType"
                              :on-item-changed="handleCtnrTypeChanged(item)"
                           >
               </auto-complete-master-data-select>
            </template>
            <template v-else>
              <md-field>
                <label>Load In Cont. type</label>
                <md-input v-model="item.ctnrType" disabled></md-input>
              </md-field>
            </template>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <md-field>
                 <label>Cnt Drop-off</label>
                 <md-input v-model="item.containerDropOffLocation" disabled></md-input>
               </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <template v-if="item.editing">
               <datepicker v-model="item.chzEndDate" >
                    <label>Ingate Date</label>
               </datepicker>
            </template>
            <template v-else>
               <md-field>
                 <label>Ingate Date</label>
                 <md-input v-model="item.chzEndDate" disabled></md-input>
               </md-field>
            </template>
         </div>
       </div>   
       <div class=" md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Appointment</label>
               <md-input v-model="item.appointment" :disabled="!item.editing"></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
             <template v-if="item.editing">
               <datepicker v-model="item.apptDate" >
                    <label>Appt. Date</label>
               </datepicker>
             </template>
             <template v-else>
               <md-field>
                 <label>Appt. date</label>
                 <md-input v-model="item.apptDate" disabled></md-input>
               </md-field>
             </template>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Appt. time</label>
               <md-input v-model="item.apptTime" :disabled="!item.editing"></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
            <template v-if="item.editing">
               <auto-complete-select
                           :options="dispRateCostList"
                           label="Rate Type"
                           :value="item.freightType"
                           :on-item-changed="handleRateCost(item)"
                        >
               </auto-complete-select>
            </template> 
            <template v-else>
               <md-field>
                 <label>Rate Type</label>
                 <md-input v-model="item.freightType" disabled></md-input>
               </md-field>   
            </template>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
          </div>
       </div>
       <div class="  md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Dispatch Instruction</label>
               <md-input v-model="item.dispatcherInstruction" :disabled="!item.editing"></md-input>
            </md-field>
         </div>
       </div>   
       <div class="  md-layout md-gutter md-alignment-center ">
         <!--<div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">-->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
              <template v-if="item.editing">
                 <auto-complete-select
                      label="Driver"
                      :options="drivers"
                      :value="item.driverId"
                      :on-item-changed="changeAsgDriverId(item)"
                  >
                 </auto-complete-select>    
              </template> 
              <template v-else>
                <md-field>
                   <label>Driver</label>
                   <md-input v-model="item.driverId" disabled></md-input>
                </md-field>
              </template>
          </div>
          <!--
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
          </div>
         -->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
                <md-field>
                   <label>Seq#</label>
                   <md-input v-model="item.stage" disabled></md-input>
                </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="GST_STAGE_STATUS"
                              label="Stage Status"
                              :init-value="item.stageStatus"
                              :on-item-changed="handleStageStatusChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Stage Status</label>
                   <md-input v-model="item.stageStatus" disabled></md-input>
                </md-field>
             </template>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_COSTREL_STATUS"
                              label="Cost Rel"
                              :init-value="item.costRelevant"
                              :on-item-changed="handleCostRelChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Cost Rel</label>
                   <md-input v-model="item.costRelevant" disabled></md-input>
                </md-field>
             </template>
          </div> 
       </div>   
      </div> 
      <div v-if="item.show && isToShowLoadOut(item.stageType)">
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="STC_TERMINAL"
                              label="Pick up terminal"
                              :init-value="item.containerPickupLocation"
                              :on-item-changed="handlePickupTermChanged(item)"
                           >
               </auto-complete-master-data-select>
               </template>
               <template v-else>
                  <md-field>
                     <label>Pick up terminal</label>
                     <md-input v-model="item.containerPickupLocation" :disabled = !item.editing></md-input>
                  </md-field>
               </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Container #</label>
                   <md-input v-model="item.containerNo" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Carrier</label>
                   <md-input v-model="paramList.carrier" disabled></md-input>
                 </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="GST_CTNRTYPE"
                              label="Cont. Type"
                              :init-value="item.ctnrType"
                              :on-item-changed="handleCtnrTypeChanged(item)"
                           >
                 </auto-complete-master-data-select>
               </template>
               <template v-else>
                 <md-field>
                   <label>Cont. type</label>
                   <md-input v-model="item.ctnrType" disabled></md-input>
                 </md-field>
               </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Seal #</label>
                   <md-input v-model="paramList.sealNumber" :disabled = !item.editing></md-input>
                </md-field>
             </div>
         </div>
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Appointment#</label>
                   <md-input v-model="item.appointment" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Appt. date</label>
                   <md-input v-model="item.apptDate" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Appt. time</label>
                   <md-input v-model="item.apptTime" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <auto-complete-select
                           :options="dispRateCostList"
                           label="Rate Type"
                           :value="item.freightType"
                           :on-item-changed="handleRateCost(item)"
                        >
               </auto-complete-select>
               </template> 
               <template v-else>
                  <md-field>
                     <label>Rate Type</label>
                     <md-input v-model="item.freightType" disabled></md-input>
                  </md-field>   
               </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             </div>
         </div>
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>BOL#</label>
                   <md-input v-model="item.bolNum" disabled></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>PIN #</label>
                   <md-input v-model="item.pinNum" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             </div>
         </div>
         <div class="  md-layout md-gutter md-alignment-center ">
         <!--<div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">-->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
              <template v-if="item.editing">
                 <auto-complete-select
                      label="Driver"
                      :options="drivers"
                      :value="item.driverId"
                      :on-item-changed="changeAsgDriverId(item)"
                  >
                 </auto-complete-select>    
              </template> 
              <template v-else>
                <md-field>
                   <label>Driver</label>
                   <md-input v-model="item.driverId" disabled></md-input>
                </md-field>
              </template>
          </div>
          <!--
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
          </div>
         -->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
                <md-field>
                   <label>Seq#</label>
                   <md-input v-model="item.stage" disabled></md-input>
                </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="GST_STAGE_STATUS"
                              label="Stage Status"
                              :init-value="item.stageStatus"
                              :on-item-changed="handleStageStatusChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Stage Status</label>
                   <md-input v-model="item.stageStatus" disabled></md-input>
                </md-field>
             </template>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_COSTREL_STATUS"
                              label="Cost Rel"
                              :init-value="item.costRelevant"
                              :on-item-changed="handleCostRelChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Cost Rel</label>
                   <md-input v-model="item.costRelevant" disabled></md-input>
                </md-field>
             </template>
          </div> 
       </div>   

      </div>
      <div v-if="item.show && isToShowEmptyIn(item.stageType)">
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Drop off terminal</label>
                   <md-input v-model="item.containerDropOffLocation" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Container #</label>
                   <md-input v-model="item.containerNo" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                 <md-field>
                   <label>Carrier</label>
                   <md-input v-model="paramList.carrier" disabled></md-input>
                 </md-field>
               
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                 <md-field>
                   <label>Cont. type</label>
                   <md-input v-model="paramList.ctnrType" disabled></md-input>
                 </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Seal #</label>
                   <md-input v-model="paramList.sealNumber" :disabled = !item.editing></md-input>
                </md-field>
             </div>
         </div> 
         <div class="md-layout md-gutter md-alignment-center">
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Chassis#</label>
                   <md-input v-model="item.chassisNumber" disabled></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                                 group="STC_CHASSIS_VENDOR"
                                 label="Chassis Vendor"
                                 :init-value="item.chassisVendor"
                                 :on-item-changed="handleChassisVendorChanged(item)"
                           >
                  </auto-complete-master-data-select>
              </template> 
              <template v-else>
                <md-field>
                  <label>Chassis Vendor</label>
                  <md-input v-model="item.chassisVendor" disabled></md-input>
                </md-field>
              </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             </div>
         </div>                 
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Appointment#</label>
                   <md-input v-model="item.appointment" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Appt. date</label>
                   <md-input v-model="item.apptDate" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Appt. time</label>
                   <md-input v-model="item.apptTime" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
               <template v-if="item.editing">
                  <auto-complete-select
                           :options="dispRateCostList"
                           label="Rate Type"
                           :value="item.freightType"
                        >
                  </auto-complete-select>
               </template> 
               <template v-else>
                  <md-field>
                    <label>Rate Type</label>
                    <md-input v-model="item.freightType" disabled></md-input>
                  </md-field>   
               </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             </div>
         </div>   
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Dispatch Instruction</label>
                   <md-input v-model="item.dispatchInst" :disabled = !item.editing></md-input>
                </md-field>
             </div>
         </div> 
         <div class="  md-layout md-gutter md-alignment-center ">
         <!--<div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">-->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
              <template v-if="item.editing">
                 <auto-complete-select
                      label="Driver"
                      :options="drivers"
                      :value="item.driverId"
                      :on-item-changed="changeAsgDriverId(item)"
                  >
                 </auto-complete-select>    
              </template> 
              <template v-else>
                <md-field>
                   <label>Driver</label>
                   <md-input v-model="item.driverId" disabled></md-input>
                </md-field>
              </template>
          </div>
          <!--
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
          </div>
         -->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
                <md-field>
                   <label>Seq#</label>
                   <md-input v-model="item.stage" disabled></md-input>
                </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="GST_STAGE_STATUS"
                              label="Stage Status"
                              :init-value="item.stageStatus"
                              :on-item-changed="handleStageStatusChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Stage Status</label>
                   <md-input v-model="item.stageStatus" disabled></md-input>
                </md-field>
             </template>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_COSTREL_STATUS"
                              label="Cost Rel"
                              :init-value="item.costRelevant"
                              :on-item-changed="handleCostRelChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Cost Rel</label>
                   <md-input v-model="item.costRelevant" disabled></md-input>
                </md-field>
             </template>
          </div> 
       </div>   

      </div>
      <div v-if="item.show && isToShowEmptyOut(item.stageType)">
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Booking</label>
                   <md-input v-model="item.bookingNo" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                 <md-field>
                   <label>Carrier</label>
                   <md-input v-model="paramList.carrier" disabled></md-input>
                 </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                 <auto-complete-master-data-select
                              group="GST_CTNRTYPE"
                              label="Cont. Type"
                              :init-value="item.ctnrType"
                              :on-item-changed="handleCtnrTypeChanged(item)"
                           >
                 </auto-complete-master-data-select>
               </template>
               <template v-else>
                 <md-field>
                   <label>Cont. type</label>
                   <md-input v-model="item.ctnrType" disabled></md-input>
                 </md-field>
               </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="GST_LOCATION"
                              label="Cnt Pick-up"
                              :init-value="item.containerPickUpLocation"
                              :on-item-changed="handleCtnrPickupLocChanged(item)"
                           >
                 </auto-complete-master-data-select>
               </template>
               <template v-else>
                <md-field>
                   <label>Cnt Pick-up</label>
                   <md-input v-model="item.containerPickUpLocation" :disabled = !item.editing></md-input>
                </md-field>
                </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             </div>
         </div>       
         <div class="md-layout md-gutter md-alignment-center">
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Appointment#</label>
                   <md-input v-model="item.appointment" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Appt. date</label>
                   <md-input v-model="item.apptDate" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Appt. time</label>
                   <md-input v-model="item.apptTime" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Dispatcher</label>
                   <md-input v-model="item.dispatcher" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
               <template v-if="item.editing">
                  <auto-complete-select
                           :options="dispRateCostList"
                           label="Rate Type"
                           :value="item.freightType"
                        >
                  </auto-complete-select>
               </template> 
               <template v-else>
                  <md-field>
                    <label>Rate Type</label>
                    <md-input v-model="item.freightType" disabled></md-input>
                  </md-field>   
               </template>
             </div>
         </div>
         <div class="  md-layout md-gutter md-alignment-center ">
         <!--<div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">-->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
              <template v-if="item.editing">
                 <auto-complete-select
                      label="Driver"
                      :options="drivers"
                      :value="item.driverId"
                      :on-item-changed="changeAsgDriverId(item)"
                  >
                 </auto-complete-select>    
              </template> 
              <template v-else>
                <md-field>
                   <label>Driver</label>
                   <md-input v-model="item.driverId" disabled></md-input>
                </md-field>
              </template>
          </div>
          <!--
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
          </div>
         -->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
                <md-field>
                   <label>Seq#</label>
                   <md-input v-model="item.stage" disabled></md-input>
                </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="GST_STAGE_STATUS"
                              label="Stage Status"
                              :init-value="item.stageStatus"
                              :on-item-changed="handleStageStatusChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Stage Status</label>
                   <md-input v-model="item.stageStatus" disabled></md-input>
                </md-field>
             </template>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_COSTREL_STATUS"
                              label="Cost Rel"
                              :init-value="item.costRelevant"
                              :on-item-changed="handleCostRelChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Cost Rel</label>
                   <md-input v-model="item.costRelevant" disabled></md-input>
                </md-field>
             </template>
          </div> 
       </div>   

      </div>
      <div v-if="item.show && (isToShowChassisIn(item.stageType) || isToShowChassisOut(item.stageType))">
         <div class="md-layout md-gutter md-alignment-center">
            <!--<div v-if="isToShowChassisIn(item.stageType)" class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">-->
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              label="Chassis pickup location"
                              :prepared-options="getMasterDataAsSelectOptionByGroup('GST_LOCATION')"
                              :init-value="item.chassisPickupLocation"
                              :on-item-changed="handleChassisPickupLocChanged(item)"
                           >
               </auto-complete-master-data-select>
               </template>
               <template v-else>
               <md-field>
                   <label>Chassis pickup location</label>
                   <md-input v-model="item.chassisPickupLocation" disabled></md-input>
                </md-field>
               </template>
             </div>
             <!--<div v-if="isToShowChassisOut(item.stageType)" class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">-->
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  
                  <auto-complete-master-data-select
                              group="STC_TERMINAL"
                              label="Chassis pickup term"
                              :init-value="item.chassisPickupTerm"
                              :on-item-changed="handleChassisPickupTermChanged(item)"
                           >
               </auto-complete-master-data-select>
            <!--
            <auto-complete-master-data-select
                              label="Chassis pickup term"
                              :prepared-options="terminals"
                              :init-value="item.chassisPickupTerm"
                              :on-item-changed="handleChassisPickupTermChanged(item)"
                           >
               </auto-complete-master-data-select>
            
               <auto-complete-select
                    label="Chassis pickup term"
                    :options="terminals"
                    :value="item.chassisPickupTerm"
                    :on-item-changed="handleChassisPickupTermChanged(item)"
                    >
               </auto-complete-select>     
            -->
               </template>
               <template v-else>
                <md-field>
                   <label>Chassis pickup term</label>
                   <md-input v-model="item.chassisPickupTerm" disabled></md-input>
                </md-field>
               </template> 
               </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="GST_LOCATION"
                              label="Chassis dropoff location"
                              :init-value="item.chassisDropOffLocation"
                              :on-item-changed="handleChassisDropOffLocChanged(item)"
                           >
               </auto-complete-master-data-select>
               </template>
               <template v-else>
               <md-field>
                   <label>Chassis dropoff location</label>
                   <md-input v-model="item.chassisDropOffLocation" disabled></md-input>
                </md-field>
               </template>
               </div>
             <!--<div v-if="isToShowChassisOut(item.stageType)" class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">-->
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="STC_TERMINAL"
                              label="Chassis dropoff term"
                              :init-value="item.chassisDropOffTerm"
                              :on-item-changed="handleChassisDropOffTermChanged(item)"
                           >
               </auto-complete-master-data-select>
               </template>
               <template v-else>
                <md-field>
                   <label>Chassis dropoff term</label>
                   <md-input v-model="item.chassisDropOffTerm" :disabled = !item.editing></md-input>
                </md-field>
                </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Chassis#</label>
                   <md-input v-model="item.chassisNo" disabled></md-input>
                </md-field>
               </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="GST_CTNRTYPE"
                              label="Chassis size"
                              :init-value="item.chassisSize"
                              :on-item-changed="handleChassisSizeChanged(item)"
                           >
               </auto-complete-master-data-select>
            </template>
            <template v-else>
              <md-field>
                <label>Chassis size</label>
                <md-input v-model="item.chassisSize" disabled></md-input>
              </md-field>
            </template>

               <!--
                <md-field>
                   <label>Chassis size</label>
                   <md-input v-model="item.chassisSize" :disabled = !item.editing></md-input>
                </md-field>
               --> 
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                 <auto-complete-master-data-select
                                 group="STC_CHASSIS_VENDOR"
                                 label="Chassis Vendor"
                                 :init-value="item.chassisVendor"
                                 :on-item-changed="handleChassisVendorChanged(item)"
                           >
                 </auto-complete-master-data-select>
              </template> 
              <template v-else>
                <md-field>
                  <label>Chassis Vendor</label>
                  <md-input v-model="item.chassisVendor" disabled></md-input>
                </md-field>
              </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
               <template v-if="item.editing">
                  <auto-complete-select
                           :options="dispRateCostList"
                           label="Rate Type"
                           :value="item.freightType"
                           :on-item-changed="handleRateCost(item)"
                        >
               </auto-complete-select>
               </template> 
               <template v-else>
                  <md-field>
                    <label>Rate Type</label>
                    <md-input v-model="item.freightType" disabled></md-input>
                  </md-field>   
               </template>
             </div>
         </div>   
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Dispatch Instruction</label>
                   <md-input v-model="item.dispatchInst" :disabled = !item.editing></md-input>
                </md-field>
             </div>
         </div> 
         <div class="  md-layout md-gutter md-alignment-center ">
         <!--<div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">-->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
              <template v-if="item.editing">
                 <auto-complete-select
                      label="Driver"
                      :options="drivers"
                      :value="item.driverId"
                      :on-item-changed="changeAsgDriverId(item)"
                  >
                 </auto-complete-select>    
              </template> 
              <template v-else>
                <md-field>
                   <label>Driver</label>
                   <md-input v-model="item.driverId" disabled></md-input>
                </md-field>
              </template>
          </div>
          <!--
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
          </div>
         -->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
                <md-field>
                   <label>Seq#</label>
                   <md-input v-model="item.stage" disabled></md-input>
                </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="GST_STAGE_STATUS"
                              label="Stage Status"
                              :init-value="item.stageStatus"
                              :on-item-changed="handleStageStatusChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Stage Status</label>
                   <md-input v-model="item.stageStatus" disabled></md-input>
                </md-field>
             </template>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_COSTREL_STATUS"
                              label="Cost Rel"
                              :init-value="item.costRelevant"
                              :on-item-changed="handleCostRelChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Cost Rel</label>
                   <md-input v-model="item.costRelevant" disabled></md-input>
                </md-field>
             </template>
          </div> 
       </div>   

      </div>
      <div v-if="item.show && isToShowTransfer(item.stageType)">
         <div class="  md-layout md-gutter md-alignment-center ">
         <!--<div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">-->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
              <template v-if="item.editing">
                 <auto-complete-select
                      label="Driver"
                      :options="drivers"
                      :value="item.driverId"
                      :on-item-changed="changeAsgDriverId(item)"
                  >
                 </auto-complete-select>    
              </template> 
              <template v-else>
                <md-field>
                   <label>Driver</label>
                   <md-input v-model="item.driverId" disabled></md-input>
                </md-field>
              </template>
          </div>
          <!--
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
          </div>
         -->
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
                <md-field>
                   <label>Seq#</label>
                   <md-input v-model="item.stage" disabled></md-input>
                </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="GST_STAGE_STATUS"
                              label="Stage Status"
                              :init-value="item.stageStatus"
                              :on-item-changed="handleStageStatusChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Stage Status</label>
                   <md-input v-model="item.stageStatus" disabled></md-input>
                </md-field>
             </template>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_COSTREL_STATUS"
                              label="Cost Rel"
                              :init-value="item.costRelevant"
                              :on-item-changed="handleCostRelChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Cost Rel</label>
                   <md-input v-model="item.costRelevant" disabled></md-input>
                </md-field>
             </template>
          </div> 
       </div>   
         <div class="md-layout md-gutter md-alignment-center">
         </div>   
      </div>



    </div>


  
    <!--<md-button class="md-raised custButton " @click="doNew"><span class="icons-center material-icons">create</span>Add Stages</md-button>-->
    <!--
    <md-button class="md-raised custLongButton " @click="doNew"><span class="icons-center material-icons">add</span>Add Load Out</md-button>
    <md-button class="md-raised custLongButton " @click="doNewOutGate"><span class="icons-center material-icons">add</span>Add Empty In</md-button>
    <md-button class="md-raised custLongButton " @click="doNewTransfer"><span class="icons-center material-icons">add</span>Add Empty Out</md-button>
    <md-button class="md-raised custLongButton " @click="doNewChassisOut"><span class="icons-center material-icons">add</span>Add Chassis In</md-button>
    <md-button class="md-raised custLongButton " @click="doNewChassisOut"><span class="icons-center material-icons">add</span>Add Chassis Out</md-button>
    <md-button class="md-raised custLongButton " @click="doNewChassisOut"><span class="icons-center material-icons">add</span>Add Transfer</md-button>
    -->
    <br/><br/><br/>
    </div>

</template>
<style scoped>
.dropbtn {
  background-color: #3498DB;
  color: white;
  padding: 16px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}

/* Dropdown button on hover & focus */
.dropbtn:hover, .dropbtn:focus {
  background-color: #2980B9;
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  /*display: none;*/
  /*position: absolute;*/
  /*position: relative;*/
  position: fixed;
  background-color: #f1f1f1;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  /*z-index: -1;*/
  z-index: 100;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {background-color: #ddd;}

/* Show the dropdown menu (use JS to add this class to the .dropdown-content container when the user clicks on the dropdown button) */
.show {display:block;}
</style>

<script>

/* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  //import api from "../api";
  import { newAPIPost } from '../api';
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";
  import OutboundBooking from '../components/OutboundBooking.vue';
  import { GlobalAccelerator } from '@aws-sdk/client-global-accelerator';


const initList = () => ({
  mode : null,
  carrier: null,
  loadKey: null,
  route: null,
  deliveryOrder: null,
  ctnrType: null,
  cutLFD: null,
  loadStatus: null,
  customerOrder: null,
  containerNo: null,
  chassisNo: null,
  chassisVendor: null,
  appointment: null,
  apptDate: null,
  apptTime: null,
  salesOffice: null,
  seqNo: null,
  bookingNo: null,
  receivingWindow: null,
  pushStatus: null,
  chzEndDate: null,
  inYardDate: null,
  dispatcher: null,
  sealNumber: null,
  driverGroup: null,
  driverId: null,
  custId: null,
  usedDay: null,
  grade: null,
  ctnrPickup: null,
  ctnrDropOff: null,
  gwDate: null,
  bolNum: null
});

const initInOutTransSave = () => ({
  bookingNo: null,
  stageStatus: null,
  stage: null,
  costRel: null,
  freightType: null,
  driverId: null,
  carrier: null,
  ctnrType: null,
  cntPickUp: null,
  cntDropOff: null,
  appointment: null,
  truckId: null,
  containerNo: null,
  chassisNo: null,
  dispatcher: null,
  apptDate: null,
  apptTime: null,
  dispatchInst: null,
})

const initChzOutSave = () => ({
   stageStatus: null,
   stage: null,
   ctnrType: null,
})

const initDispatchLoadSearch = () => ({
    receivingWindow: null,
    salesOffice: null,
    pickupLocation: null,
    bookingNo: null,
    destination: null,
    appointment: null,
    driverId: null,
    driverGroup: null,
    costRelevant: null,
    freightType: null,
    cargoCutOff: {
      startDate: null,
      endDate: null,
    },
    apptDate: {
      startDate: null,
      endDate: null,
    },
    loadKey: null,
    source: null,
    containerNo: null,
    chassisNo: null,
    carrier: null,
    customerOrder: null,
    deliveryOrder: null,
    loadStatus: [],
    pushStatus: null,
    stageType: null,
    filter: null,
    fromPage: null,
    selectDType: null
})

const getInitDriverSearch = () => ({
     source: null,
     driverOffice: null,
     defaultSalesOffice: null
})

const initLoadAsgBk = () => ({
     ctnrType: null,
     grade: null,
     carrier: null 
})

const initLoadUnAsgBk = () => ({
     deliveryOrder: null,
     bookObl: null,
     ibs: null,
     seqNo: null
})

const initUpdateSend = () => ({
     seqNo: null,
     stages: [],
})

export default {

    data: () => ({
     paramList: initList(), 

     saveInOutTrans: initInOutTransSave(),
     saveChzOut: initChzOutSave(),
     dispatchLoadSearch: initDispatchLoadSearch(),
     searchDriverReq: getInitDriverSearch(),
     loadAsgBkInfo: initLoadAsgBk(),
     loadUnAsgBkInfo: initLoadUnAsgBk(),
     reqUpdateSend: initUpdateSend(),
     loadList: [],
     params: null,
     pointer: null,
     items: null,
     indicator: false,
     drivers: [],
     driverIds: [],
     driverNames: [],
     driverContent: [],
     dispRateCostList: [],
     dispRateCostCodes: [],
     stageTypeList: [],
     terminals: [],
     showInOutTrans: true,
     showChzOut: false,
     defaultDisabled: true,
     itemCount: null,
     driverId: null,
     carrier: null,
     disableAsgBk: true,
     disableUnAsgBk: true,
     showDropDown: false,
     loadHide: false,
     isLoadIn: false,
     isLoadOut: false,
     isEmptyOut: false,
     isEmptyIn: false,
     isChassisIn: false,
     isChassisOut: false,
     isTransfer: false,
     loadEdit: false,
     disableLoadAsgBk: true,
     disableLoadUnAsgBk: true,
     show: true,
     showLISel: false,
     showEISel: false,
     showEOSel: false,
     showCISel: false,
     showCOSel: false,
     showTSel: false,
     debug: false
    }),


    components: {
      callingApiCenter,
      AutocompleteCcicLocationSelect,
      OutboundBooking,
    },


    computed: {
        ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
        'getGSTDriverMaster',
        'getBillRateByCategory'
      ]),

      canLast(){
        //return this.pointer == 0;
        console.log("canLast: " + this.pointer + " loadList length: " + this.loadList.length);
        if (this.pointer > 0 && this.loadList && this.loadList.length > 1) {
        //this.pointer == 0;
           console.log("return canlast false");
           return false;
        }   
        else {
           console.log("return canlast true");
           return true;
        }      
      },


      canNext(){
         console.log("canNext: " + this.pointer + " , " + this.loadList + " loadList length: " + this.loadList.length);
         if (this.loadList && (this.pointer <  this.loadList.length - 1)) {
             console.log("return canNext false");
             return false; //endable button
         }    
         else {
             console.log("return canNext true");
             return true;  //disable button
         }        
      //   if (this.loadList && this.loadList.length >= 1){
      //      //return this.pointer == this.loadList.length - 1;
      //      this.pointer == this.loadList.length - 1;
      //      console.log("do next: " + this.pointer);
      //      return false;
      //   }   
      //   else
      //   {
      //      //return 0; 
      //      console.log("can't do next: " + this.pointer);
      //      return true;  
      //   }  
      },

      // getAssignBookingCond(item) {
      //    if (item.bookingNo == null || item.bookingNo == "") 
      //        return false; 
      //    else return true;
      // },

      // getUnAssignBookingCond() { 
      //    // console.log("unassign cond");
      //    // const item = _(this.items).filter((it) => it.selected);
      //    // const sapStatus = _(this.items).filter((it) => it.sapStatus != 'X');
      //    // if (sapStatus.length == 0) return false
      //    // console.log("unassign item length:" + item.length);
      //    // return item.length === 1 && item[0].loadStatus == 'ASN'
      //    return false;
      // },



    },

    


    async mounted() {
        
       this.searchDriverReq.driverOffice = "STC";
       this.searchDriverReq.defaultSalesOffice = "LGB";
       this.$store.dispatch('gstDriverMaster', this.searchDriverSearchReq);
       this.updateDrivers(this.getGSTDriverMaster);
       console.log("drivers from getter: " + this.drivers);
       this.getSTCTerminal();
       //var dispRateCost = JSON.parse(JSON.stringify(this.getBillRateByCategory("DRIVER"))); 
       var dispRateCost = this.getBillRateByCategory("DRIVER"); 
       console.log("dispRateCost: " + JSON.stringify(dispRateCost));
       if (dispRateCost) {
          dispRateCost.forEach( (it) => {
             this.dispRateCostCodes.push(it.tagId);
             this.dispRateCostList.push(it.tagName + "(" + it.tagId + ")");
             console.log("dispRateCost item: " + it.tagId + ", name: " + it.tagName);
          })
       } 
        console.log("name: " + this.$route.name);
        //console.log("route params: " + JSON.parse(this.$route.params.req));
        console.log("route params: " + JSON.parse(this.$route.params.req));
        console.log("route params1: " + this.$route.params.req);
        console.log("route params2: " + this.$route.params.searchCriteria);

        this.loadList = JSON.parse(this.$route.params.req);
        var searchCriteria = JSON.parse(this.$route.params.searchCriteria);
        console.log("containerNo: " + searchCriteria.containerNo);
        this.dispatchLoadSearch.containerNo = searchCriteria.containerNo;
        this.dispatchLoadSearch.receivingWindow = searchCriteria.receivingWindow;
        this.dispatchLoadSearch.salesOffice = searchCriteria.salesOffice;
        this.dispatchLoadSearch.pickUpLocation = searchCriteria.pickUpLocation;
        this.dispatchLoadSearch.bookingNo = searchCriteria.bookingNo;
        this.dispatchLoadSearch.destination = searchCriteria.destination;
        this.dispatchLoadSearch.appointment = searchCriteria.appointment;
        this.dispatchLoadSearch.driveId = searchCriteria.driverId;
        this.dispatchLoadSearch.driverGroup = searchCriteria.driverGroup;
        this.dispatchLoadSearch.costRelevant = searchCriteria.costRelevant;
        this.dispatchLoadSearch.freightType = searchCriteria.freightType;
        this.dispatchLoadSearch.cargoCutOff.startDate = searchCriteria.cargoCutOff.startDate;
        this.dispatchLoadSearch.cargoCutOff.endDate = searchCriteria.cargoCutOff.endDate;
        this.dispatchLoadSearch.apptDate.startDate = searchCriteria.apptDate.startDate;
        this.dispatchLoadSearch.apptDate.endDate = searchCriteria.apptDate.endDate;
        this.dispatchLoadSearch.loadKey = searchCriteria.loadKey;
        this.dispatchLoadSearch.source = searchCriteria.source;
        this.dispatchLoadSearch.chassisNo = searchCriteria.chassisNo;
        this.dispatchLoadSearch.carrier = searchCriteria.carrier;
        this.dispatchLoadSearch.customerOrder = searchCriteria.customerOrder;
        this.dispatchLoadSearch.deliveryOrder = searchCriteria.deliveryOrder;
        this.dispatchLoadSearch.loadStatus = searchCriteria.loadStatus;
        this.dispatchLoadSearch.pushStatus = searchCriteria.pushStatus;
        this.dispatchLoadSearch.stageType = searchCriteria.stageType;
        this.dispatchLoadSearch.filter = searchCriteria.filter;
        this.dispatchLoadSearch.fromPage = searchCriteria.fromPage;
        this.dispatchLoadSearch.selectDType = searchCriteria.selectDType;
        console.log("loadList: " + this.loadList[0].mode);
        console.log("loadList length: " + this.loadList.length);
        this.pointer = 0;
        if (this.loadList) {
           this.params = this.loadList[0];
           if (this.params) {
             console.log("loading paramList keys");
             this.paramList.mode = this.params.mode;
             this.paramList.carrier = this.getDisplay("STC_CARRIER",this.params.carrier);
             this.paramList.loadKey = this.params.loadKey;
             this.paramList.route = this.params.route;
             this.paramList.deliveryOrder = this.params.deliveryOrder;
             this.paramList.ctnrType = this.getDisplay("GST_CTNRTYPE",this.params.ctnrType);
             //this.paramList.ctnrType = this.params.ctnrType;
             this.paramList.cutLFD = this.params.cutLFD;
             this.paramList.loadStatus = this.params.loadStatus;
             this.paramList.customerOrder = this.params.customerOrder;
             this.paramList.containerNo = this.params.containerNo;
             this.paramList.chassisNo = this.params.chassisNo;
             this.paramList.chassisVendor = this.getDisplay("STC_CHASSIS_VENDOR",this.params.chassisVendor);
             this.paramList.appointment = this.params.appointment;
             //this.paramList.apptDate = dateFormat.getLocalDate(this.params.apptDate);
             this.paramList.apptDate = this.getDate(this.params.apptDate);
             this.paramList.apptTime = this.params.apptTime;
             this.paramList.salesOffice = this.params.salesOffice;
             this.paramList.seqNo = this.params.seqNo;
             this.paramList.bookingNo = this.params.bookingNo;
             this.paramList.receivingWindow = this.params.receivingWindow;
             this.paramList.pushStatus = this.getPushStatusInfo(this.params.pushStatus);
             //this.paramList.ctnrType = this.params.ctnrType;
             this.paramList.chzEndDate = this.getDate(this.params.chzEndDate);
             this.paramList.dispatcher = this.params.createdBy;
             this.paramList.sealNumber = this.params.sealNumber;
             this.paramList.driverGroup = this.params.driverGroup;
             this.paramList.driverId = this.params.driverId;
             this.paramList.custId = this.params.custId;
             this.paramList.usedDay = this.getChassisUsedDate(this.params);
             this.paramList.inYardDate = this.params.inYardDate;
             this.paramList.grade = this.params.grade;
             //this.paramList.ctnrDropOff = this.params.containerDropOffLocation;
             //this.paramList.ctnrPickup = this.params.containerPickupLocation;
             this.paramList.ctnrDropOff = this.params.dropOffTerm;
             this.paramList.ctnrPickup = this.params.pickupTerm;
             this.paramList.gwDate = this.getDate(this.params.gwDate);
             this.paramList.bolNum = this.params.bolNum;

             this.paramList.loadKeyWithStageNo = this.params.loadKeyWithStageNo;
             this.paramList.doProcess = this.params.doProcess;
           }
           this.pointer = 0;
           console.log("paramList: " + this.paramList);
        }
      this.checkStageTypeListOpt(this.paramList.mode);  
      //   this.drivers = null;
      //   this.$store.dispatch('getUsersByCategory', { category: 'L' })
      //     .then((res) => {
      //       this.drivers = res;
      //   });
        await this.doSearch().then( () => {
            console.log("mounted: after search: items: " + this.items);
            if (!this.items || this.items.length < 1) {
               //console.log("items length: " + this.items.length); 
               //if (this.items.length < 1) {
               if (this.paramList.mode == "YY") {
                  console.log("call doAddStage");
                  this.doAddStage("LI");
                  //console.log("dd_li: " + document.getElementById("dd_li"));
                  if (this.items)
                    console.log("mounted: after doAddStage items length: " + this.items.length + " items[0] show: " + this.items[0].show);
               } else if (this.paramList.mode == "YI") {
                  console.log("set YI with mode: " + this.paramList.mode);
                  this.doAddStage("LO");
               }
               else {
                  console.log("no mode match in mount: " + this.paramList.mode);
               }
            }
        })
          

          

          


    },
    methods: {
        doAction(){

            this.$router.go(-1);
            // var request = this.dispatchLoadSearch;
            // console.log("req: " + JSON.stringify(request));
            // if (request.fromPage == "L" ) {
            // this.$router.push({  
            // name: "Load" , 
            // params: { req: JSON.stringify(request) }})
            // }
            // else {
            //    this.$router.push({  
            //      name: "Stage" , 
            //      params: { req: JSON.stringify(request) }})
            // }
        },

        doBack(){
          
          this.pointer = this.pointer - 1;
          this.params = this.loadList[this.pointer];
          if (this.params) {
             console.log("loading paramList keys");
            //  this.paramList.mode = this.params.mode;
            //  this.paramList.carrierName = this.params.carrierName;
            //  this.paramList.loadKey = this.params.loadKey;
            //  this.paramList.route = this.params.route;
            //  this.paramList.deliveryOrder = this.params.deliveryOrder;
            //  this.paramList.ctnrType = this.params.ctnrType;
            //  this.paramList.cutLFD = this.params.cutLFD;
            //  this.paramList.loadStatus = this.params.loadStatus;
            //  this.paramList.customerOrder = this.params.customerOrder;
            //  this.paramList.containerNo = this.params.containerNo;
            //  this.paramList.chassisNo = this.params.chassisNo;
            //  this.paramList.appointment = this.params.appointment;
            //  this.paramList.salesOffice = this.params.salesOffice;
            //  this.paramList.seqNo = this.params.seqNo;
            //  this.paramList.bookingNo = this.params.bookingNo;
            this.paramList.mode = this.params.mode;
            this.paramList.carrier = this.getDisplay("STC_CARRIER",this.params.carrier);
            this.paramList.loadKey = this.params.loadKey;
            this.paramList.route = this.params.route;
            this.paramList.deliveryOrder = this.params.deliveryOrder;
            this.paramList.ctnrType = this.getDisplay("GST_CTNRTYPE",this.params.ctnrType);
            //this.paramList.ctnrType = this.params.ctnrType;
            this.paramList.cutLFD = this.params.cutLFD;
            this.paramList.loadStatus = this.params.loadStatus;
            this.paramList.customerOrder = this.params.customerOrder;
            this.paramList.containerNo = this.params.containerNo;
            this.paramList.chassisNo = this.params.chassisNo;
            this.paramList.chassisVendor = this.getDisplay("STC_CHASSIS_VENDOR",this.params.chassisVendor);
            this.paramList.appointment = this.params.appointment;
            //this.paramList.apptDate = dateFormat.getLocalDate(this.params.apptDate);
            this.paramList.apptDate = this.getDate(this.params.apptDate);
            this.paramList.apptTime = this.params.apptTime;
            this.paramList.salesOffice = this.params.salesOffice;
            this.paramList.seqNo = this.params.seqNo;
            this.paramList.bookingNo = this.params.bookingNo;
            this.paramList.receivingWindow = this.params.receivingWindow;
            this.paramList.pushStatus = this.getPushStatusInfo(this.params.pushStatus);
            //this.paramList.ctnrType = this.params.ctnrType;
            this.paramList.chzEndDate = this.getDate(this.params.chzEndDate);
            this.paramList.dispatcher = this.params.createdBy;
            this.paramList.sealNumber = this.params.sealNumber;
            this.paramList.driverGroup = this.params.driverGroup;
            this.paramList.driverId = this.params.driverId;
            this.paramList.custId = this.params.custId;
            this.paramList.usedDay = this.getChassisUsedDate(this.params);
            this.paramList.inYardDate = this.params.inYardDate;
            this.paramList.grade = this.params.grade;
            //this.paramList.ctnrDropOff = this.params.containerDropOffLocation;
            //this.paramList.ctnrPickup = this.params.containerPickupLocation;
            this.paramList.ctnrDropOff = this.params.dropOffTerm;
            this.paramList.ctnrPickup = this.params.pickupTerm;
            this.paramList.gwDate = this.getDate(this.params.gwDate);
            this.paramList.bolNum = this.params.bolNum;

            this.paramList.loadKeyWithStageNo = this.params.loadKeyWithStageNo;
            this.paramList.doProcess = this.params.doProcess;
         }
          this.doSearch();

        },

        async doNext(){
          console.log("doNext");
          this.pointer = this.pointer + 1;
          this.params = this.loadList[this.pointer];
          if (this.params) {
             console.log("loading paramList keys");
            //  this.paramList.mode = this.params.mode;
            //  this.paramList.carrierName = this.params.carrierName;
            //  this.paramList.loadKey = this.params.loadKey;
            //  this.paramList.route = this.params.route;
            //  this.paramList.deliveryOrder = this.params.deliveryOrder;
            //  this.paramList.ctnrType = this.params.ctnrType;
            //  this.paramList.cutLFD = this.params.cutLFD;
            //  this.paramList.loadStatus = this.params.loadStatus;
            //  this.paramList.customerOrder = this.params.customerOrder;
            //  this.paramList.containerNo = this.params.containerNo;
            //  this.paramList.chassisNo = this.params.chassisNo;
            //  this.paramList.appointment = this.params.appointment;
            //  this.paramList.salesOffice = this.params.salesOffice;
            //  this.paramList.seqNo = this.params.seqNo;
            //  this.paramList.bookingNo = this.params.bookingNo;
            this.paramList.mode = this.params.mode;
            this.paramList.carrier = this.getDisplay("STC_CARRIER",this.params.carrier);
            this.paramList.loadKey = this.params.loadKey;
            this.paramList.route = this.params.route;
            this.paramList.deliveryOrder = this.params.deliveryOrder;
            this.paramList.ctnrType = this.getDisplay("GST_CTNRTYPE",this.params.ctnrType);
            //this.paramList.ctnrType = this.params.ctnrType;
            this.paramList.cutLFD = this.params.cutLFD;
            this.paramList.loadStatus = this.params.loadStatus;
            this.paramList.customerOrder = this.params.customerOrder;
            this.paramList.containerNo = this.params.containerNo;
            this.paramList.chassisNo = this.params.chassisNo;
            this.paramList.chassisVendor = this.getDisplay("STC_CHASSIS_VENDOR",this.params.chassisVendor);
            this.paramList.appointment = this.params.appointment;
            //this.paramList.apptDate = dateFormat.getLocalDate(this.params.apptDate);
            this.paramList.apptDate = this.getDate(this.params.apptDate);
            this.paramList.apptTime = this.params.apptTime;
            this.paramList.salesOffice = this.params.salesOffice;
            this.paramList.seqNo = this.params.seqNo;
            this.paramList.bookingNo = this.params.bookingNo;
            this.paramList.receivingWindow = this.params.receivingWindow;
            this.paramList.pushStatus = this.getPushStatusInfo(this.params.pushStatus);
            //this.paramList.ctnrType = this.params.ctnrType;
            this.paramList.chzEndDate = this.getDate(this.params.chzEndDate);
            this.paramList.dispatcher = this.params.createdBy;
            this.paramList.sealNumber = this.params.sealNumber;
            this.paramList.driverGroup = this.params.driverGroup;
            this.paramList.driverId = this.params.driverId;
            this.paramList.custId = this.params.custId;
            this.paramList.usedDay = this.getChassisUsedDate(this.params);
            this.paramList.inYardDate = this.params.inYardDate;
            this.paramList.grade = this.params.grade;
            //this.paramList.ctnrDropOff = this.params.containerDropOffLocation;
            //this.paramList.ctnrPickup = this.params.containerPickupLocation;
            this.paramList.ctnrDropOff = this.params.dropOffTerm;
            this.paramList.ctnrPickup = this.params.pickupTerm;
            this.paramList.gwDate = this.getDate(this.params.gwDate);
            this.paramList.bolNum = this.params.bolNum;
          }
          await this.doSearch().then ( () => {
          if (!this.items || this.items.length < 1) {
               //console.log("items length: " + this.items.length); 
               //if (this.items.length < 1) {
               if (this.paramList.mode == "YY" || this.paramList.mode == "YE") {
                  console.log("call doAddStage");
                  this.doAddStage("LI");
                  //console.log("dd_li: " + document.getElementById("dd_li"));
                  if (this.items)
                    console.log("mounted: after doAddStage items length: " + this.items.length + " items[0] show: " + this.items[0].show);
               } else if (this.paramList.mode == "YI") {
                  console.log("set YI with mode: " + this.paramList.mode);
                  this.doAddStage("LO");
               } else if (this.paramList.mode == "YT") {
                  this.doAddStage("T"); 
               } else {
                  console.log("no mode match in mount: " + this.paramList.mode);
               }
            }
         })
        },


        
   doConfirm() {
         if (this.paramList.loadStatus != "DCP"){
            window.confirm('LoadStatus is not DCP')
            return;
         }
         if (this.paramList.doProcess != "O"){
            window.confirm('DO process is not Open(O)!')
            return;
         }

         const seqNo = this.paramList.seqNo;
         //api
         //   .post("/api/w/apar/create", {
         newAPIPost("/api/w/apar/create", {
               mode: "loadCFM",
               user: "GST_SYSTEM",
               username: this.getUserProfile.username,
               billingDate: dateFormat.getLocalDateOnly(moment().toDate()),
               refDoc: seqNo,
               seqNo: seqNo,
               deliveryOrder: this.paramList.deliveryOrder,
               salesOffice: this.paramList.salesOffice
            })
            .then((res) => {
               this.showDialog = true;
               this.$store.commit("clearApiError");
               this.paramList.loadStatus = "CFM";
               this.params.loadStatus = "CFM";
               window.confirm(res);
            });

         // api
         //    .post("/api/w/gst/WebConfirmLoad", {
         //       mode: "loadCFM",
         //       user: "GST_SYSTEM",
         //       username: this.getUserProfile.username,
         //       billingDate: dateFormat.getLocalDateOnly(moment().toDate()),
         //       refDoc: seqNo,
         //       seqNo: seqNo,
         //       deliveryOrder: this.paramList.deliveryOrder,
         //       salesOffice: this.paramList.salesOffice
         //    })
         //    .then((res) => {
         //       this.showDialog = true;
         //       this.$store.commit("clearApiError");
         //       this.paramList.loadStatus = "CFM";
         //       this.params.loadStatus = "CFM";
         //       window.confirm(res);
         //    });
         this.doSearch();
        
      },

      doConfirmStage(item) {



         if (this.getStageStatusCode(item.stageStatus) != "DCP"){
            window.confirm('Stage Status is not DCP')
            return;
         }

         if (item.costRelevant == "Cost Relevant(Y)"){

            if (item.driverId == "" || item.driverId == null){
               window.confirm('Driver information missing!')
               return;
            }

            if (this.getRateCostCode(item.freightType) == "" || this.getRateCostCode(item.freightType) == null){
               window.confirm('Freight Type information missing!')
               return;
            }

            const seqNo = this.paramList.seqNo;
            //api
            //   .post("/api/w/apar/create", {
            newAPIPost("/api/w/apar/create", {
                  mode: "stageCFM",
                  user: "GST_SYSTEM",
                  username: this.getUserProfile.username,
                  billingDate: this.convertDateForConfirm(this.paramList.chzEndDate,"-"),
                  refDoc: item.loadKeyWithStageNo,
                  seqNo: seqNo,
                  deliveryOrder: this.paramList.deliveryOrder,
                  salesOffice: this.paramList.salesOffice,
                  rateType: item.freightType,
                  pf: "DR",
                  partner: item.driverId,
                  settleDate: this.convertDateForConfirm(this.paramList.chzEndDate,"-")
               })
               .then((res) => {
                  item.stageStatus = "CFM";
                  this.showDialog = true;
                  this.$store.commit("clearApiError");
                  window.confirm(res);
               });

            // api
            //    .post("/api/w/gst/WebConfirmLoad", {
            //       mode: "stageCFM",
            //       user: "GST_SYSTEM",
            //       username: this.getUserProfile.username,
            //       billingDate: dateFormat.getLocalDateOnly(moment().toDate()),
            //       refDoc: item.loadKeyWithStageNo,
            //       seqNo: seqNo,
            //       deliveryOrder: this.paramList.deliveryOrder,
            //       salesOffice: this.paramList.salesOffice,
            //       rateType: item.freightType,
            //       pf: "DR",
            //       partner: item.driverId
            //    })
            //    .then((res) => {
            //       item.stageStatus = "CFM";
            //       this.showDialog = true;
            //       this.$store.commit("clearApiError");
            //       window.confirm(res);
            //    });
               // this.doSearch();
         }

         if (item.costRelevant == "Cost Relevant(N)" || item.costRelevant == "Cost Relevant()" || item.costRelevant == null ){
            //api
            //.post("/api/w/apar/create", {
            newAPIPost("/api/w/apar/create", {
               mode: "stageCMN",
               user: "GST_SYSTEM",
               username: this.getUserProfile.username,
               refDoc: item.loadKeyWithStageNo
            })
            .then((res) => {
               item.stageStatus = "CMN";
               this.showDialog = true;
               this.$store.commit("clearApiError");
               window.confirm(res);
            });

            // api
            // .post("/api/w/gst/WebConfirmLoad", {
            //    mode: "stageCMN",
            //    user: "GST_SYSTEM",
            //    username: this.getUserProfile.username,
            //    refDoc: item.loadKeyWithStageNo
            // })
            // .then((res) => {
            //    item.stageStatus = "CMN";
            //    this.showDialog = true;
            //    this.$store.commit("clearApiError");
            //    window.confirm(res);
            // });
               // this.doSearch();
         }

      },


        doAddStage(stageType) {
           // this.showInOutTrans = true;
           // this.showChzOut = false;
           //initial stage type check
           var defaultCostRel = "";
           var defaultFreightType = "";
           var defaultStage = "";
           var group = "STC_LOAD_STAGES_" + this.paramList.mode;
           console.log("add stage group: " + group); 
           const defaultVal = this.getMasterDataByGroup(group).filter(it => it.tagId === stageType);
           //const defaultVal = this.getMasterDataByGroup(group);
           //console.log("load stage: " + JSON.stringify(defaultVal[2]));
           console.log("load stage: " + JSON.stringify(defaultVal));
           if (defaultVal && defaultVal.length >= 0) {
              defaultCostRel = defaultVal[0].from;
              defaultFreightType = defaultVal[0].chassisVendorType;
           }
           console.log("defaultcostrel: " + defaultCostRel + " , defaultfreighttype" + defaultFreightType);

           console.log("doAddStage: " + stageType);
           this.isEmptyIn = false;
           this.isEmptyOut = false;
           this.isLoadIn = false;
           this.isChassisIn = false;
           this.isChassisOut = false;
           this.isTransfer = false;
           this.isLoadOut = false;
           if (stageType == "EO") {
               this.isEmptyOut = true;
               console.log("isEmptyOut: " + this.isEmptyOut);
           }    
           if (stageType == "EI") {
               this.isEmptyIn = true;
               console.log("isEmptyIn: " + this.isEmptyIn);
           }    
           if (stageType == "CI") {
               this.isChassisIn = true;
               console.log("isChassisIn: " + this.isChassisIn);
           }    
           if (stageType == "CO") {
               this.isChassisOut = true;
               console.log("isChassisOut: " + this.isChassisOut);
           }    
           if (stageType == "T") {
               this.isTransfer = true;
               console.log("isTransfer: " + this.isTransfer);
           }    
           if (stageType == "LO") {
               this.isLoadOut = true;
               console.log("isLoadOut: " + this.isLoadOut);
           }    
           if (stageType == "LI") {
               this.isLoadIn = true;
               console.log("isLoadIn: " + this.isLoadIn);
           }    
           if (this.paramList.bookingNo != null && this.paramList.bookingNo != "")
           {
              this.disableAsgBk = true;
              this.disableUnAsgBk = false;
           }
           else {
              this.disableAsgBk = false;
              this.disableUnAsgBk = true; 
           }
            //this.disableAsgBk = false;
            this.showDropDown = false;
            var setStage = "";
            if (this.items) {
               this.itemCount = this.items.length;
               setStage = (this.items.length + 1).toString() + "0";
            } else {
               this.itemCount = 1;
               setStage = "10";
            }

            var loadAppt = null;
            var loadApptDate = null;
            var loadApptTime = null;
            if (stageType == "LI") {
               loadAppt = this.params.appointment;
               loadApptDate = this.params.apptDate;
               loadApptTime = this.params.apptTime;
            }

            
            console.log("do new - seq: " + this.itemCount + " setStage: " + setStage);
            if (!this.items) this.items = [];
            this.items.push({
            receivingWindow: this.paramList.receivingWindow,   
            stage: setStage,  
            salesOffice: this.paramList.salesOffice,
            loadKeyWithStageNo: null,
            stageStatus: null,
            //appointment: null,
            //apptDate: null,
            //apptTime: null,
            appointment: loadAppt,
            apptDate: loadApptDate,
            apptTime: loadApptTime,
            driverId: null,
            truckId: null,
            costRelevant: (defaultCostRel && defaultCostRel != "")? this.getCostRelFromCode("Y"): null,
            freightType: (defaultFreightType && defaultFreightType != "")? this.getRateCostFromCode(defaultFreightType): null,
            dispatcherInstruction: null,
            containerPickupLocation: this.paramList.ctnrPickup,
            containerDropOffLocation: this.paramList.ctnrDropOff,
            offsiteScale: null,
            ccicDropOffLocationCode: null,
            pickupDate: null,
            seqNo: this.paramList.seqNo,
            user: "GST_SYSTEM",
            pickupLocationCode: null,
            pickUpLocationName: null,
            deliverLocationCode: null,
            deliverLocationName: null,
            deliveryOrder: this.paramList.deliveryOrder,
            //stageType: "I",
            stageType: stageType,
            bookingNo: this.paramList.bookingNo,
            containerNo: this.paramList.containerNo,
            ctnrType: this.paramList.ctnrType,
            bolNum: this.paramList.bolNum,
            grade: this.paramList.grade,
            sealNumber: this.paramList.sealNumber,
            chassisNo: this.paramList.chassisNo,
            chassisVendor: this.paramList.chassisVendor,
            inYardDate: this.paramList.inYardDate,
            chzEndDate: this.paramList.chzEndDate,
            carrier: null,
            editing : true,
            remove: false,
            newitem: true,
            show: true
            });

        },

        doNew(){

            //var stageTypeInName = this.getStageTypeInfo(type);
            this.showInOutTrans = true;
            this.showChzOut = false;
            this.disableAsgBk = false;
            this.itemCount = this.items.length;
            var setStage = (this.items.length + 1).toString() + "0";
            console.log("do new - seq: " + this.itemCount + " setStage: " + setStage);
            this.items.push({
            stage: setStage,  
            salesOffice: this.params.salesOffice,
            loadKeyWithStageNo: null,
            stageStatus: null,
            appointment: null,
            apptDate: null,
            apptTime: null,
            driverId: null,
            truckId: null,
            costRelevant: null,
            freightType: null,
            dispatcherInstruction: null,
            containerPickupLocation: null,
            containerDropOffLocation: null,
            offsiteScale: null,
            ccicDropOffLocationCode: null,
            pickupDate: null,
            // seqNo: it.loadKey,
            pickupLocationCode: null,
            pickUpLocationName: null,
            deliverLocationCode: null,
            deliverLocationName: null,
            deliveryOrder: this.params.deliveryOrder,
            stageType: "I",
            stageBookingNo: this.params.bookingNo,
            editing : true,
            remove: false,
            newitem: true
            });
        },
 
        doNewOutGate() {
          this.showInOutTrans = true;
          this.showChzOut = false;
          this.disableAsgBk = false;
          var setStage = (this.items.length + 1).toString() + "0";
          console.log("donewoutgate - seq: " + this.itemCount + " setStage: " + setStage);
          this.items.push({
            stage: setStage,  
            salesOffice: this.params.salesOffice,
            loadKeyWithStageNo: null,
            stageStatus: null,
            appointment: null,
            apptDate: null,
            apptTime: null,
            driverId: null,
            truckId: null,
            costRelevant: null,
            freightType: null,
            dispatcherInstruction: null,
            containerPickupLocation: null,
            containerDropOffLocation: null,
            offsiteScale: null,
            ccicDropOffLocationCode: null,
            pickupDate: null,
            // seqNo: it.loadKey,
            pickupLocationCode: null,
            pickUpLocationName: null,
            deliverLocationCode: null,
            deliverLocationName: null,
            deliveryOrder: this.params.deliveryOrder,
            stageType: "O",
            stageBookingNo: this.params.bookingNo,
            editing : true,
            remove: false,
            newitem: true
            });

        },
        doNewTransfer() {
          this.showInOutTrans = true;
          this.showChzOut = false;
          this.disableAsgBk = false;
          var setStage = (this.items.length + 1).toString() + "0";
          console.log("donewtransfer - seq: " + this.itemCount + " setStage: " + setStage);
          this.items.push({
            stage: setStage,  
            salesOffice: this.params.salesOffice,
            loadKeyWithStageNo: null,
            stageStatus: null,
            appointment: null,
            apptDate: null,
            apptTime: null,
            driverId: null,
            truckId: null,
            costRelevant: null,
            freightType: null,
            dispatcherInstruction: null,
            containerPickupLocation: null,
            containerDropOffLocation: null,
            offsiteScale: null,
            ccicDropOffLocationCode: null,
            pickupDate: null,
            // seqNo: it.loadKey,
            pickupLocationCode: null,
            pickUpLocationName: null,
            deliverLocationCode: null,
            deliverLocationName: null,
            deliveryOrder: this.params.deliveryOrder,
            stageType: "T",
            stageBookingNo: this.params.bookingNo,
            editing : true,
            remove: false,
            newitem: true
            });

        },
        doNewChassisOut() {
          this.showChzOut = true;
          this.showInOutTrans = false;
          this.disableAsgBk = true;
          var setStage = (this.items.length + 1).toString() + "0";
          console.log("donewchassisout - seq: " + this.itemCount + " setStage: " + setStage);
          this.items.push({
            stage: setStage,  
            salesOffice: this.params.salesOffice,
            loadKeyWithStageNo: null,
            stageStatus: null,
            appointment: null,
            apptDate: null,
            apptTime: null,
            driverId: null,
            truckId: null,
            costRelevant: null,
            freightType: null,
            dispatcherInstruction: null,
            containerPickupLocation: null,
            containerDropOffLocation: null,
            offsiteScale: null,
            ccicDropOffLocationCode: null,
            pickupDate: null,
            // seqNo: it.loadKey,
            pickupLocationCode: null,
            pickUpLocationName: null,
            deliverLocationCode: null,
            deliverLocationName: null,
            deliveryOrder: this.params.deliveryOrder,
            stageType: "CO",
            stageBookingNo: null,
            editing : true,
            remove: false,
            newitem: true
            });

        },

        doLoadEdit() {
            this.loadEdit = true;
            this.disableLoadAsgBk = false;
            if (this.paramList.bookingNo == null || this.paramList.bookingNo == "")
               this.disableLoadUnAsgBk = true;
            else
               this.disableLoadUnAsgBk = false;   
        },

        doLoadCancel() {
            this.loadEdit = false;
            this.disableLoadAsgBk = true;
            this.disableLoadUnAsgBk = true;
        },

        doLoadSave() {

        },

        async doLoadSend() {
           var unsave = false;
           
           this.reqUpdateSend.seqNo = this.paramList.seqNo;
           //api.post('/api/w/stc/updateDispatchSend', this.reqUpdateSend).then ( (res) => {
           newAPIPost('/api/w/stc/updateDispatchSend', this.reqUpdateSend).then ( (res) => {
              
           }) 
        },

        async doSend(item) {
           if (item.newitem) {alert("Please Save and try again"); return} 
           this.reqUpdateSend.stages.push(item.loadKeyWithStageNo); 
           //api.post('/api/w/stc/updateDispatchSend', this.reqUpdateSend).then ( (res) => {
           newAPIPost('/api/w/stc/updateDispatchSend', this.reqUpdateSend).then ( (res) => {
              alert("Stage status updated to 'Dispatched'");
              this.doSearch();
           }) 
        },

        async doSendAll() {
           var unsave = false;
           this.reqUpdateSend.seqNo = this.paramList.seqNo;
           this.items.forEach( (it) => {
             if (it.newitem == true) {unsave = true;}
             if (it.loadKeyWithStageNo) {
                var foundObj = this.reqUpdateSend.stages.filter( it => it === it.loadKeyWithStageNo );
                if (foundObj && foundObj.length < 1)
                   this.reqUpdateSend.stages.push(it.loadKeyWithStageNo); 
             }   
           }) 
           if (!unsave) {
             //api.post('/api/w/stc/updateDispatchSend', this.reqUpdateSend).then ((res) => {
             newAPIPost('/api/w/stc/updateDispatchSend', this.reqUpdateSend).then ((res) => {
               alert("Load and Stage status updated to 'Dispatched'");
               this.doSearch();
             })
           } else {
             alert("Please Save and try again");
           }   
        },

      //   changeAsgDriverId(isLoad) {
      //      console.log("asg driver is for : " + isLoad);
      //      //return (id, name, unit, weight, plate, trail) => {
      //      return (driver) => {  
      //        this.paramList.driverId = driver;
      //        console.log("load driver Id in item: " + this.paramList.driverId);
      //      };
      //   },
        changeAsgDriverId(item) {
           return (driver) => {
               item.driverId = driver;
               console.log("Asg driver Id: " + item.driverId)
           }
        },

        getLoadBookingAssign() {
         var loads = [];
         this.loadAsgBkInfo.grade = this.paramList.grade;
         this.loadAsgBkInfo.ctnrType = this.paramList.ctnrType;
         this.loadAsgBkInfo.carrier = this.paramList.carrier;
         loads.push(this.loadAsgBkInfo);
         this.$refs.OutboundBooking.openDialog(loads);

        },

        getLoadBookingUnAssign() {
         if (!window.confirm('Unassign the Load In booking?')) {
           return;
         }
        
         //const load = this.getSelectedItems
         //var loads = [];
         //this.loadUnAsgBkInfo.deliveryOrder = this.paramList.deliveryOrder;
         //this.loadUnAsgBkInfo.bookObl = this.paramList.bookingNo;
         //this.loadUnAsgBkInfo.ibs = this.paramList.ibs;
         //this.loadUnAsgBkInfo.seqNo = this.paramList.seqNo;
         //loads.push(this.loadUnAsgBkInfo);
         const office = 'LGB'
         //const si = loads[0].deliveryOrder
         //const obk = loads[0].bookObl
         //const ibds = loads[0].ibs
         //const usr = 'GST_SYSTEM'
         //const seqn = loads[0].seqNo
         const si = this.paramList.deliveryOrder;
         const obk = this.paramList.bookingNo;
         const usr = 'GST_SYSTEM';
         const seqn = this.paramList.seqNo;
         console.log("Set load Unassign");
         const request = {
           salesOffice: office,
           deliveryOrder: si,
           //ibs: ibds,
           user: usr,
           seqNo: seqn,
         };

         console.log(JSON.stringify(request));
         //api.post("/api/w/DOs/WebUnAssignBooking", request).then((res) => {
         newAPIPost("/api/w/DOs/WebUnAssignBooking", request).then((res) => {
            this.showDialog = false;
            this.$store.commit("clearApiError");
            this.action(si, obk, 'UASN', seqn);
    
 
         });

        },

        async updateDrivers(itemsSource) {
          var items = itemsSource;
          if (items && items.length > 0) {  
             items.forEach((it) => {
                var driverInfo = it.shortId + "(" + it.userName + ")";
                this.drivers.push(driverInfo);
                this.driverIds.push(it.driverId);
                this.driverNames.push(it.userName);
                this.driverContent.push(driverInfo);
             })
          } else {
             //await api.post('/api/w/gstMasterData/driverMasterData', this.searchDriverReq)
             await newAPIPost('/api/w/gstMasterData/driverMasterData', this.searchDriverReq)
                 .then ( (driverinfo) => {
                    if (driverinfo) {
                        driverinfo.forEach( (it) => {
                            console.log("driver: " + it.shortId);
                            var driverInfo = it.shortId + "(" + it.userName + ")";
                            this.drivers.push(driverInfo);
                            this.driverIds.push(it.driverId);
                            this.driverNames.push(it.userName);
                            this.driverContent.push(driverInfo);
                        })
                    }
             });
          }
          console.log("drivers: [[" + this.drivers + "]]");
          // console.log("update drivers itemsource: " + JSON.stringify(itemsSource));
          // var items = JSON.stringify(itemsSource);
          // var items1 = JSON.parse(items);
          // console.log("update drivers: " + items + ", " + items1);
          // // items.forEach(it => {
             
          // // })
          // console.log("items1 length: " + items1.length);
          // items1.forEach((it) => {
          //    console.log("items: " + JSON.stringify(it.shortId));
          //    var driverinfo = JSON.stringify(it.shortId);
          //    this.drivers.push(driverinfo);
          // })
          // //this.drivers = items;
          // console.log("drivers: " + this.drivers);
          
         //  await api.post('/api/w/gstMasterData/driverMasterData', this.searchDriverReq)
         //         .then ( (driverinfo) => {
         //            if (driverinfo) {
         //                driverinfo.forEach( (it) => {
         //                    console.log("driver: " + it.shortId);
         //                    this.drivers.push(it.shortId + "(" + it.userName + ")");
         //                    this.driverIds.push(it.driverId);
         //                    this.driverNames.push(it.userName);
         //                    this.driverContent.push(it.shortId + "(" + it.userName + ")");
         //                })
         //            }
         //         });
         //  console.log("drivers: [[" + this.drivers + "]]");
        },

        doEdit(item){
            console.log(item);

            if (item.stageStatus == 'STC' || item.stageStatus == 'SUC'  )
              {
                alert('The stage has been confirmed or under check, it can not be changed this time!');
                return;
              }
            item.editing = true;
            item.remove = false;
            this.indicator = true;
            console.log("edit booking: " + item.bookingNo);
            if (item.stageType == "LI" || item.stageType == "EO") {
               if (item.bookingNo != null && item.bookingNo != "") {
                  this.disableAsgBk = true;
                  this.disableUnAsgBk = false;
               }   
               else {
                  this.disableAsgBk = false;  
                  this.disableUnAsgBk = true; 
               }   
            } else {
               this.disableAsgBk = true;
               this.disableUnAsgBk = true; 
            }
          
        },


        doSave(item)
        {
         console.log("freight type: " + item.freightType);
          if (item.loadKeyWithStageNo != null)
          {
            //update
            console.log("item remove: " + item.remove + ", carrier: " + item.carrier);
              const request = {
            companyOffice : 'GST_' + this.params.salesOffice,
            loadKey : this.params.loadKey || this.params.seqNo,
            loadKeyWithStageNo: item.loadKeyWithStageNo,
            stageStatus: this.getStageStatusCode(item.stageStatus),
            appointment: item.appointment,
            apptDate: dateFormat.getLocalDate(item.apptDate),
            apptTime: item.apptTime,
            //driverId: this.driverId,
            driverId: this.getdriverUserNameFromDriver(item.driverId),
            truckId: item.truckId,
            costRelevant: item.costRelevant,
            freightType: this.getRateCostCode(item.freightType),
            chassisVendor: this.getchassisVendorCode(item.chassisVendor),
            dispatcherInstruction: item.dispatcherInstruction,
            containerPickupLocation: item.containerPickUpLocation,
            containerDropOffLocation: item.containerDropOffLocation,
            offsiteScale: item.offsiteScale,
            ccicDropOffLocationCode: item.ccicDropOffLocationCode,
            pickupDate: dateFormat.getLocalDate(item.pickupDate),
            // seqNo: it.loadKey,
            pickupLocationCode: item.pickupLocationCode,
            pickUpLocationName: item.pickUpLocationName,
            deliverLocationCode: item.deliverLocationCode,
            deliverLocationName: item.deliverLocationName,
            deliveryOrder: item.deliveryOrder,
            //stageType: item.stageType,
            stageType: item.type,
            //bookingNo: item.stageBookingNo,
            bookingNo: item.bookingNo,
            //carrier: this.carrier,
            carrier: item.carrier,
            pinNum: item.pinNo,
            bolNum: item.bolNo,
            chassisPickupLocation: item.chassisPickupLocation,
            chassisPickupTerm: item.chassisPickupTerm,
            chassisDropOffLocation: item.chassisDropOffLocation,
            chassisDropOffTerm: item.chassisDropOffTerm,
            chassisSize: this.getChassisSizeCode(item.chassisSize),
            disabled: item.remove
            }
            if (request.stageTypeWithStatus == null) 
            {request.stageTypeWithStatus = this.params.mode}
            request.mode = this.params.mode;
            request.action = 'CHANGE';


          console.log(request);
         
      
        // await Promise.all(this.getEditingItems.map(it => api.post('/api/w/ccic/application/update', it)));
         
         //api.post("/api/w/gst/createyardstage", request)
         newAPIPost("/api/w/gst/createyardstage", request)
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
             item.editing = false;
          });
          }
          else
          {
            //create
            console.log("bookingNo: " + item.stageBookingNo + " driverId: " + item.driverId);
            const req = {
            companyOffice : 'GST_' + this.params.salesOffice,
            loadKey : this.params.loadKey || this.params.seqNo,
            stageStatus: this.getStageStatusCode(item.stageStatus),
            appointment: item.appointment,
            apptDate: dateFormat.getLocalDate(item.apptDate),
            apptTime: item.apptTime,
            //driverId: this.driverId,
            driverId: this.getdriverUserNameFromDriver(item.driverId),
            carrier: item.carrier,
            truckId: item.truckId,
            costRelevant: item.costRelevant,
            freightType: this.getRateCostCode(item.freightType),
            chassisVendor: this.getchassisVendorCode(item.chassisVendor),
            dispatcherInstruction: item.dispatcherInstruction,
            containerPickupLocation: item.containerPickUpLocation,
            containerDropOffLocation: item.containerDropOffLocation,
            offsiteScale: item.offsiteScale,
            ccicDropOffLocationCode: item.ccicDropOffLocationCode,
            pickupDate: dateFormat.getLocalDate(item.pickupDate),
            // seqNo: it.loadKey,
            pickupLocationCode: item.pickupLocationCode,
            pickUpLocationName: item.pickUpLocationName,
            deliverLocationCode: item.deliverLocationCode,
            deliverLocationName: item.deliverLocationName,
            deliveryOrder: item.deliveryOrder,
            stageType: item.stageType,
            //bookingNo: item.stageBookingNo,
            bookingNo: item.bookingNo,
            pinNum: item.pinNo,
            bolNum: item.bolNo,
            chassisPickupLocation: item.chassisPickupLocation,
            chassisPickupTerm: item.chassisPickupTerm,
            chassisDropOffLocation: item.chassisDropOffLocation,
            chassisDropOffTerm: item.chassisDropOffTerm,
            chassisSize: this.getChassisSizeCode(item.chassisSize),
            disabled: item.remove,
            }
            // if (this.params.mode == "YT")
            // {
            //   req.stageType = "T"
            // }
            // else
            // {
            //   req.stageType = "IN"
            // }
            if (req.stageTypeWithStatus == null) 
            {req.stageTypeWithStatus = this.params.mode}
            req.mode = this.params.mode;
            req.action = 'CREATE';
            console.log(req);
             //api.post("/api/w/gst/createyardstage", req)
             newAPIPost("/api/w/gst/createyardstage", req)
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
             item.editing = false;
            
          });
          }
            

        },

      doAddLoadOut() {
           this.showDropDown = false;
      },

    
      doChkRemoveAndSave(item) {
         var index = 0;
         var removeIndx = 0;
         if (item.remove == false) {
            this.doSave(item);
         }
         else {
            if (item.newitem == true) {
               removeIndx = this.getItemIndx(index, item.stage);
               console.log("indx: " + removeIndx);
               if (removeIndx > -1)
                  this.items.splice(removeIndx, 1);
               console.log("items length after remove: " + this.items.length);
               this.items.forEach((it) => {
                  console.log("item: " + JSON.stringify(it));
               })
            } else {
               this.doSave(item);
            }
         }
      },

      doHideItem(item) {
         // var itemIndx = 0;
         // var found = false;
         // var searchStage = item.stage;
         // var setVal = false;
         // this.itemToHideStage.forEach( (it) => {
         //    if (it != searchStage && !found) {
         //       itemIndx += 1;
         //    } else {
         //       console.log("itemToHide index: " + itemIndx);
         //       found = true;
         //    }
         // })
         // setVal = !this.itemToHide[itemIndx];
         // console.log("setVal: " + setVal);
         // this.itemToHide[itemIndx] = setVal;
         // //return returnVal;
         item.show = !item.show;
      },


      // chkItemToHide(item) {
      //    var itemIndx = 0;
      //    var found = false;
      //    var searchStage = item.stage;
      //    //var setVal = false;
      //    this.itemToHideStage.forEach( (it) => {
      //       if (it != searchStage && !found) {
      //          itemIndx += 1;
      //       } else {
      //          console.log("itemToHide index: " + itemIndx);
      //          found = true;
      //       }
      //    })
      //    //setVal = !this.itemToHide[itemIndx];
      //    console.log("return Val: " + this.itemToHide[itemIndx]);
      //    return this.itemToHide[itemIndx];
      // },

      getItemIndx(indx, stage) {
         var itemindx = indx;
         var found = false;
         console.log("items length: " + this.items.length);
         console.log("getitemindex: stage: " + stage);
         this.items.forEach((it) => {
            console.log("item stage: " + it.stage);
            if (it.stage != stage && !found) {
               itemindx += 1;
            }
            else { 
               console.log("return in loop" + itemindx );
               //return itemindx;
               found = true;
            }
         }) 
         console.log("return " + itemindx );
         //console.log("return -1");
         return itemindx;
         //return -1;
      },

      async onfresh(id, ticket, mode, loads) {
         console.log(`${id} , ${ticket} , ${mode}`);
         this.notifyMessage =  null;

         switch(mode)
         {
           case 'STR':
              this.notifyMessage = `Load ${id} has been scaled tw with scale ticket: ${ticket}.`;
           break;

           case 'SWR':
              this.notifyMessage = `Load ${id} with scale ticket: ${ticket} has been scaled gw.`;
           break;

           case 'ASN':
              this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
           break;

           case 'UASN':
              this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
           break;

           default:
           break;
         }
      
         //this.doSearch();
       },

      handleStageStatusChanged(stage) {
        return (id) => {
          stage.stageStatus = id;
        };
      },

      handleGradeChanged(item) {
         return(id) => {
            item.grade = id;
         }
      },

      handleChassisVendorChanged(item) {
         return (id) => {
            item.chassisVendor = id;
         }
      },

      handleCtnrTypeChanged(item) {
         return (id) => {
            item.ctnrType = id;
         } 
      },

      handleWindowsChanged(item) {
         return (id) => {
            item.receivingWindow = id;
         }
      },


      handleDriverChanged() {
         return (id, name, unit, weight, plate, trail) => {
          //console.log("itsm driverPh: " + item.driverPh);
          //item.driverPh = "";
          //console.log(`Item is ${item}`)
          //item.moveInBy = id;
          //item.driverPh = name;
          this.driverId = id;
          //console.log(`Phone is ${item.driverPh}`);
          //item.message = "3555";
          //this.$forceUpdate()
          console.log("driverId: " + id);
          //console.log("selected Items driverPh: " + item.driverPh);
          //console.log("selected item index: " + item.index);
          //if (item.index > -1)
          //{
          //    console.log("selected item driverPh: " + this.smslist[item.index].driverPh);
          //}
          //if (document.getElementById("smsoutbound"))
          //{
          //   console.log("find smsoutbound element");
          //   document.getElementById("smsoutbound").refresh;
         // }
        };
      },

      handleTruckChanged(item) {
        return (id) => {
          item.truckId = id;
        };
      },
      handleCostRelChanged(item) {
        return (id) => {
          item.costRelevant = id; 
        };
      },
      handleCntrTypeChanged(item) {
        return (id) => {
          item.ctnrType = id;
        }
      },
      handleCtnrPickupLocChanged(item) {
        return (id) => {
          item.containerPickupLocation = id;
        }
      },
      handleFreightTypeChanged(item) {
         return (id) => {
          console.log("freight type id: " + id);
          item.freightType = id;
         }
          //item.freightType = id;
          //return id;
      },       
      // handleCarrierChanged(name){
      //     console.log('carrier:' + name );
      //     this.carrier = name;
      // },

      handleCarrierChanged(item) {
         return (id, name, unit, weight, plate, trail) => {
            console.log("handle carrier: " + id + ", " + name);
            item.carrier = id;
         }
      },

      handleRateCost(item) {
         console.log("rate cost changed." + item.freightType);
         return (cost) => {
            console.log("rate cost id: " + cost);
            item.freightType = cost;
         }
      },

      handleDropOffChanged(item) {
         return ((id) => {
            item.containerDropOffLocation = id;
         })
      },

      handlePickupTermChanged(item) {
         return ((id) => {
            item.containerPickupLocation = id;
         })
      },
      
      handleChassisPickupLocChanged(item) {
         return ((id) => {
            item.chassisPickupLocation = id;
         })
      },
      handleChassisPickupTermChanged(item) {
         return ((id) => {
            console.log("chassis pickup term: " + id);
            item.chassisPickupTerm = id;
         })
      },
      handleChassisDropOffLocChanged(item) {
         return ((id) => {
            item.chassisDropOffLocation = id;
         })
      },
      handleChassisDropOffTermChanged(item) {
         return ((id) => {
            item.chassisDropOffTerm = id;
         })
      },
      handleChassisSizeChanged(item) {
         return ((id) => {
            item.chassisSize = id;
         })
      },
   //  handleDropOffLocationChanged(item) {
   //      return (pickupLocation) => {
   //        if (pickupLocation) {
   //          item.ccicDropOffLocationCode = pickupLocation.tagId;
   //          item.containerDropOffLocation = pickupLocation.tagName;
   //          // item.pickUpLocation = pickupLocation;
   //        } else {
   //           //item.pickUpLocationId = null;
   //          // item.pickUpLocationName = null;
   //          // item.pickUpLocation = null;
   //        }
   //      };
   //    },


      // handlePickupLocationChanged(item) {
      //   return (pickupLocation) => {
      //     if (pickupLocation) {
      //       item.pickUpLocationCode = pickupLocation.tagId;
      //       item.pickUpLocationName = pickupLocation.tagName;
      //       // item.pickUpLocation = pickupLocation;
      //     } else {
      //        //item.pickUpLocationId = null;
      //       // item.pickUpLocationName = null;
      //       // item.pickUpLocation = null;
      //     }
      //   };
      // },


      // handleDeliverLocationChanged(item) {
      //   return (pickupLocation) => {
      //     if (pickupLocation) {
      //       item.deliverLocationCode = pickupLocation.tagId;
      //       item.deliverLocationName = pickupLocation.tagName;
      //       // item.pickUpLocation = pickupLocation;
      //     } else {
      //        //item.pickUpLocationId = null;
      //       // item.pickUpLocationName = null;
      //       // item.pickUpLocation = null;
      //     }
      //   };
      // },

        doCancel(item){
            item.editing = false;
        },

        canEdit(item){
          return item.editing != null
      },

      async  doSearch()
    {
        if (this.params != null)
        {
            const data = {
            //loadKey: this.params.loadKey || this.params.seqNo,
            seqNo: this.params.seqNo,
            companyOffice: 'GST_' + this.params.salesOffice,
            salesOffice: this.params.salesOffice,
                }
            console.log(data);
            //await api.post("/api/w/gst/WebSearchCockpit", data)
            await newAPIPost("/api/w/stc/dispatchstagelist", data)
          .then((item) => {
            this.$store.commit('clearApiError');
            item.forEach((it) => {
            it.editing = false;
            it.show = true;
            it.remove = false;
            it.newitem = false;
            it.driverId = this.getdriverFromUsername(it.driverId);
            it.freightType = this.getRateCostFromCode(it.freightType);
            it.chassisVendor = this.getDisplay("STC_CHASSIS_VENDOR",it.chassisVendor);
            it.ctnrType = this.getDisplay("GST_CTNRTYPE",it.ctnrType);
            it.apptDate = this.convertDateForDatePicker(it.apptDate);
            it.gwDate = this.convertDateForDatePicker(it.gwDate);
            it.inYardDate = this.convertDateForDatePicker(it.inYardDate);
            it.chzEndDate = this.convertDateForDatePicker(it.chzEndDate);
            it.chassisPickupLocation = this.getLocFromCode(it.chassisPickupLocation);
            it.chassisPickupTerm = this.getTermFromCode(it.chassisPickupTerm);
            it.chassisDropOffLocation = this.getLocFromCode(it.chassisDropOffLocation);
            it.chassisDropOffTerm = this.getTermFromCode(it.chassisDropOffTerm);
            it.stageStatus = this.getStageStatusFromCode(it.stageStatus);
            it.costRelevant = this.getCostRelFromCode(it.costRelevant);
            it.chassisSize = this.getChassisSizeFromCode(it.chassisSize);
            it.loadStatus = this.params.loadStatus;
          });

            this.items = item;
            console.log("Search: " + this.items)
            // this.items.forEach( (it) => {
            //    this.itemToHide.push(true);
            //    this.itemToHideStage.push(it.stage);
            // })
          });

        }
    },

    getBookingAssign(item) {
         //const loads = this.getSelectedItems
         var loads = [];
         var bkAssignItem = item;
         bkAssignItem.ctnrType = this.getContentFromBrace(bkAssignItem.ctnrType);
         loads.push(bkAssignItem);
         if (item.newitem) { alert("Please save the new record before process BK assign"); return; }
         if (this.paramList.carrier == null || this.paramList.grade == null) {
            alert("Either carrier or grade in container is empty, please setup info and assign again!!");
         } else {
            this.$refs.OutboundBooking.openDialog(loads);
            item.bookingNo = "";
            this.disableAsgBk = true;
            this.disableUnAsgBk = false;
         }
      },

    getBookingUnAssign(item) {
         if (!window.confirm('Unassign Selected Items?')) {
           this.disableAsgBk = true;
           this.disableUnAsgBk = false; 
           return;
         }
        
         //const load = this.getSelectedItems
         // var loads = [];
         // loads.push(item);
         // const office = 'LGB'
         // const si = loads[0].deliveryOrder
         // const obk = loads[0].bookObl
         // const ibds = loads[0].ibs
         // const usr = 'GST_SYSTEM'
         // const seqn = loads[0].seqNo
         const office = 'LGB';
         const si = this.paramList.deliveryOrder;
         const obk = this.paramList.bookingNo;
         const ibds = this.paramList.ibs;
         const usr = 'GST_SYSTEM';
         const seqn = this.paramList.seqNo;
         console.log("Set Unassign");
         const request = {
           salesOffice: office,
           deliveryOrder: si,
           ibs: ibds,
           user: usr,
           seqNo: seqn,
         };

         console.log(JSON.stringify(request));
         //api.post("/api/w/DOs/WebUnAssignBooking", request).then((res) => {
         newAPIPost("/api/w/DOs/WebUnAssignBooking", request).then((res) => {
            this.showDialog = false;
            this.$store.commit("clearApiError");
            //this.action(si, obk, 'UASN', seqn);
            item.bookingNo = "";
    
 
         });
    },

    convertDateForDatePicker(date) {
        var day = "";
        var month = "";
        var year = "";

        if (date) {
           console.log("date input: " + date);
          //  if (date.toString().indexOf("T") > 0) {
          //     dateString = date.toString().substr(1, date.toString().indexOf("T") - 1);
          //     console.log("convert date for date picker: " + Date(dateString).getMonth());
          //     return moment(dateString);      
          //  }   
          //  else {
          //     return date;
          //  }
          var processDate = new Date(date);
          year = processDate.getFullYear();
          month = processDate.getMonth() + 1;
          day = processDate.getDate();
          if (month && month.toString().length < 2) {
             month = "0" + month;
          }
          if (day && day.toString().length < 2) {
             day = "0" + day;
          }
          console.log("date input in format: " +  month + "/" + day + "/" + year );
          return month + "/" + day + "/" + year;
        }
        else {
          return date;
        }
     },

    getContentFromBrace(inputVal) {
      var openbraceIndx = -1;
         var closebraceIndx = -1;
         var retVal = "";
         if (inputVal && inputVal != "") {
            openbraceIndx = inputVal.indexOf("(");
            closebraceIndx = inputVal.indexOf(")");
            if (openbraceIndx >= 1) {
               if (closebraceIndx > openbraceIndx) {
                  retVal = inputVal.substr(openbraceIndx + 1, closebraceIndx - openbraceIndx - 1);
                  console.log("retVal from brace: " + retVal);
               } else if (closebraceIndx < 0) {
                  retVal = inputVal.substr(openbraceIndx + 1, inputVal.length - openbraceIndx);
                  console.log("retVal from brace1: " + retVal);
               }
            } else {
               retVal = inputVal;
            }
            return retVal;
         } else {
            return inputVal;
         }    
    },

    getdriverUserNameFromDriver(driver) {
         return this.getContentFromBrace(driver);
    },

    getRateCostCode(RateCost) {
         var retVal = this.getContentFromBrace(RateCost);
         console.log("Rate cost return: " + retVal);
         return retVal;
    },

    getchassisVendorCode(vendor) {
         return this.getContentFromBrace(vendor);
    },

    getChassisSizeCode(size) {
         return this.getContentFromBrace(size);
    },
    
    getStageStatusCode(status) {
         return this.getContentFromBrace(status);
    },
    getSTCTerminal() {
         //const terminals = this.getMasterDataByGroup("GST_TERMINAL").filter( it => it.from == "STC");
         const terminals = this.getMasterDataByGroup("STC_TERMINAL");
         console.log("termainals: " + JSON.stringify(terminals));
         //var retTerm = [];
         terminals.forEach((it) => {
            console.log("termname: " + it.tagName + ", term id" + it.tagId);
            this.terminals.push(it.tagName + "(" + it.tagId + ")");
         })
         console.log("this terminals: " + this.terminals);
         //return retTerm;
    },
    getdriverFromUsername(username) {
         var indx = 0;
         var findIndx = -1;
         if (username && username != "") {
            this.driverNames.forEach( (it) => {
               if (it == username) {
                  findIndx = indx;
               }
               indx += 1;
            })
            if (findIndx > -1) {
               return this.drivers[findIndx];
            } else {
               return username;
            }
         } else {
            return username;
         }
    },
    getLocFromCode(code) {
       var tagname = this.getMasterDataName("GST_LOCATION",code);
       var retVal = "";
       if (!tagname) retVal = code; else retVal = tagname + "(" + code + ")";
       return retVal;
    },
    getTermFromCode(code) {
      var tagname = this.getMasterDataName("STC_TERMINAL",code);
       var retVal = "";
       if (!tagname) retVal = code; else retVal = tagname + "(" + code + ")";
       return retVal;
    },
    getStageStatusFromCode(code) {
      var tagname = this.getMasterDataName("GST_STAGE_STATUS",code);
       var retVal = "";
       if (!tagname) retVal = code; else retVal = tagname + "(" + code + ")";
       return retVal;
    },
    getCostRelFromCode(code) {
      var tagname = this.getMasterDataName("STC_COSTREL_STATUS",code);
       var retVal = "";
       if (!tagname) retVal = code; else retVal = tagname + "(" + code + ")";
       return retVal;
    },
    getChassisSizeFromCode(code) {
      var tagname = this.getMasterDataName("GST_CTNRTYPE",code);
       var retVal = "";
       if (!tagname) retVal = code; else retVal = tagname + "(" + code + ")";
       return retVal;

    },
    getRateCostFromCode(code) {
         var indx = 0;
         var findIndx = -1;
         if (code && code != "") {
            this.dispRateCostCodes.forEach( (it) => {
               if (it == code) {
                  findIndx = indx;
               }
               indx += 1;
            })
            if (findIndx > -1) {
               return this.dispRateCostList[findIndx];
            } else {
               return code;
            }
         } else {
            return code;
         }
    },

    getDisplay(group, tagId) {
      var tagname = "";
      if (!tagId) {
        return "";
      }
      tagname = this.getMasterDataName(group, tagId) || tagId;
      console.log("getdisplay tagname: " + tagname);
      return tagname + " (" + tagId + ")";
    },

    getStageTypeInfo(type) {
       var retType = "";
       console.log("in stage type: " + type);
       if (type && type != "") {
          //retType = this.getMasterDataName("STC_STAGE_TYPE",type);
          retType = this.getMasterDataName("STC_STAGE_TYPE",type);
          console.log("return type: " + retType);
       }
       if (retType == "") {
          return "In Gate";
       }   
       else {
          return retType;     
       }
    },
    getPushStatusInfo(status) {
       var retStatus = "";
       console.log("push status: " + status);
       if (status && status != "") {
          //retType = this.getMasterDataName("STC_STAGE_TYPE",type);
          retStatus = this.getMasterDataName("PUSH_STATUS",status);
          console.log("return type: " + retStatus);
       }
       return retStatus;     
    },
    setStageWindow(type) {
       if (type == "I" || type == "O" || type == "T") {
          this.showChzOut = false;
          this.showInOutTrans = true;
       } else {
         if (type == "CO") {
             this.showChzOut = true;
             this.showInOutTrans = false;
         }
         else {
             this.showChzOut = false;
             this.showInOutTrans = false;
         }
       }

          
    },
    getFreightType() {
        return  this.getMasterDataAsSelectOptionByGroup('GST_RATE_COST');
        
      },
    initShowStageType() {
       this.showLISel = false;
       this.showLOSel = false;
       this.showEISel = false;
       this.showEOSel = false;
       this.showCISel = false;
       this.showCOSel = false;
       this.showTSel = false;
    },  

    checkStageTypeListOpt(type) {
      var group = "STC_LOAD_STAGES_" + type;
      console.log("load stages group: " + group);
      const opts =  this.getMasterDataByGroup(group);
      console.log("stage type opt: " + opts + " opt length: " + opts.length); 
      this.initShowStageType();
      if (opts && opts.length >= 0) {
         var opt = opts[0];      
         var tagid = "";
         for (opt in opts) {
            console.log("load stage: " + opts[opt].tagId);
            tagid = opts[opt].tagId;
            if (tagid == "LI") this.showLISel = true;
            if (tagid == "LO") this.showLOSel = true;
            if (tagid == "EI") this.showEISel = true;
            if (tagid == "EO") this.showEOSel = true;
            if (tagid == "CI") this.showCISel = true;
            if (tagid == "CO") this.showCOSel = true;
            if (tagid == "T") this.showTSel = true;
         }
      }
      // for (var opt in opts) {
      //    console.log("stages: " + opt);
      // }
      // opts.forEach( (it) => {
      //    console.log("opts loop");
      //    if (it.tagId == "LI") this.showLISel = true; else this.showLISel = false;
      //    if (it.tagId == "LO") this.showLOSel = true; else this.showLOSel = false;
      //    if (it.tagId == "EI") this.showEISel = true; else this.showEISel = false;
      //    if (it.tagId == "EO") this.showEOSel = true; else this.showEOSel = false;
      //    if (it.tagId == "CI") this.showCISel = true; else this.showCISel = false;
      //    if (it.tagId == "CO") this.showCOSel = true; else this.showCOSel = false;
      //    if (it.tagId == "T") this.showTSel = true; else this.showTSel = false; 
      // })
    },

    isToShowInOutTrans(type) {
      if (type == "I" || type == "O" || type == "T") 
         return true;
      else 
         return false;
    },
    isToShowChzOut(type) {
      if (type == "CO") 
         return true;
      else 
         return false;
    },
    isToShowLoadIn(type) {
      console.log("isToShowLoadIn type: " + type);
      if (type == "LI")
        return true;
      else
        return false;  
    },
    isToShowLoadOut(type) {
      if (type == "LO")
         return true;
      else
         return false;   
    },
    isToShowEmptyOut(type) {
      if (type == "EO")
         return true;
      else
         return false;   
    },
    isToShowEmptyIn(type) {
      if (type == "EI")
         return true;
      else
         return false;   
    },
    isToShowChassisOut(type) {
      if (type == "CO")
         return true;
      else
         return false;   
    },
    isToShowChassisIn(type) {
      if (type == "CI")
         return true;
      else
         return false;   
    },
    isToShowTransfer(type) {
      if (type == "T")
         return true;
      else
         return false;   
    },

    getDate(date) {
      var separator = "T";
      if (date) {
         if (date.toString().indexOf(separator) > 0) {
            return date.toString().substr(0,date.toString().indexOf(separator));
         }
         else
         {
            return date.toString();
         }         
      }
      else {
         return "";
      }

    },
    getChassisUsedDate(item){
          console.log("chzStartDate: " + item.chzStartDate + " chzEndDate: " + item.chzEndDate);
          if (item.chzEndDate == null)
          {
            return moment().diff(moment(item.chzStartDate), 'days') + " days";
          }
          else
          {
            return moment(item.chzEndDate).diff(moment(item.chzStartDate), 'days') + " days";
          }
      },
      doDropDown() {
          this.showDropDown = !this.showDropDown;
      }, 
      doHide() {
          this.loadHide = !this.loadHide;
      },     

    }
    }



</script>

<style scoped>

.custButton {
    margin: 10px;
    width: 110px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
   
}

.custLongButton {
    margin: 10px;
    width: 180px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
   
}


.holder {
    /* background: blue; */
    margin: 20px;
    width: 800px;
    height: 200px;
}

.header{
    text-align: left;
}

.fixed-content {
    padding-left: 10%;
    padding-right: 10%;
    position:fixed;
    overflow-y:auto;
    overflow-x:hidden;
}

.md-layout-item {
  height: 50px;
  margin-top: 8px;
  margin-bottom: 8px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  /* border:1px solid #000; */
  /* background: #ce93d8; */
}

.md-title {
    margin-left: 20px;


}

.fieldWidth {
   width: 80px !important;
}





</style>